/* eslint-disable */
import 'reflect-metadata';
import { Mixin } from 'ts-mixer';
import { Type } from 'class-transformer';

export enum SenderType {
  User = 'USER',
  Bot = 'BOT',
  System = 'SYSTEM',
}

export enum SpeakerPosition {
  Left = 'LEFT',
  Right = 'RIGHT',
}

export enum Country {
  Korea = 'KOREA',
  Japan = 'JAPAN',
}

export enum PlotFeature {
  Facial = 'FACIAL',
  Voice = 'VOICE',
  Skin = 'SKIN',
}

export enum PlotStatus {
  Release = 'RELEASE',
  Prerelease = 'PRERELEASE',
  Filtered = 'FILTERED',
  Suspended = 'SUSPENDED',
  Deleted = 'DELETED',
  HardDeleted = 'HARD_DELETED',
}

export enum OpenStoreType {
  PlayStore = 'PLAY_STORE',
  AppStore = 'APP_STORE',
  ZetaStore = 'ZETA_STORE',
}

export enum UserPushType {
  PlotMessage = 'PLOT_MESSAGE',
  NewRecommendPlot = 'NEW_RECOMMEND_PLOT',
  CreatorNewPlot = 'CREATOR_NEW_PLOT',
  CreatorFollow = 'CREATOR_FOLLOW',
  FavoriteStory = 'FAVORITE_STORY',
}

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER',
}

export enum VoiceAgeGroup {
  Child = 'CHILD',
  YoungAdult = 'YOUNG_ADULT',
  MiddleAged = 'MIDDLE_AGED',
  Elder = 'ELDER',
}

export enum ReportStatus {
  Pending = 'PENDING',
  Confirmed = 'CONFIRMED',
}

export enum SupportCategoryType {
  All = 'ALL',
  ContactAndTemplateOnly = 'CONTACT_AND_TEMPLATE_ONLY',
  TemplateOnly = 'TEMPLATE_ONLY',
  FaqOnly = 'FAQ_ONLY',
}

export enum StoryStatus {
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Finished = 'FINISHED',
  OnHold = 'ON_HOLD',
  Deleted = 'DELETED',
}

export enum StoryEpisodeStatus {
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Deleted = 'DELETED',
}

export enum NudgeType {
  GenerateSpeed = 'GENERATE_SPEED',
  RemoveAd = 'REMOVE_AD',
  BackgroundImage = 'BACKGROUND_IMAGE',
  PrivatePlot = 'PRIVATE_PLOT',
}

export enum ProductStatus {
  Public = 'PUBLIC',
  Experimental = 'EXPERIMENTAL',
  Private = 'PRIVATE',
  Suspended = 'SUSPENDED',
}

export enum Operator {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS',
  LessThan = 'LESS_THAN',
  LessThanOrEquals = 'LESS_THAN_OR_EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEquals = 'GREATER_THAN_OR_EQUALS',
}

export enum PlotLifecycleStage {
  Released = 'RELEASED',
  ExposureEvaluation = 'EXPOSURE_EVALUATION',
  ConversationEvaluation = 'CONVERSATION_EVALUATION',
  EvaluationComplete = 'EVALUATION_COMPLETE',
  Old = 'OLD',
}

export enum ContactReplyStatus {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
  Draft = 'DRAFT',
}

export enum ChatMABExperimentModelConfigSpeakerType {
  Bot = 'BOT',
  User = 'USER',
}

export enum ChatMABExperimentModelConfigType {
  Default = 'DEFAULT',
  Gpt = 'GPT',
}

export enum DistributionType {
  Normal = 'NORMAL',
  Exponential = 'EXPONENTIAL',
}

export enum ExperimentMetadataRegenCapType {
  None = 'NONE',
  PerMessage = 'PER_MESSAGE',
  Daily = 'DAILY',
}

export enum ModelSpeakerType {
  Bot = 'BOT',
  User = 'USER',
}

export enum ModelType {
  Default = 'DEFAULT',
  Gpt = 'GPT',
}

export enum ABExperimentType {
  Default = 'DEFAULT',
  Push = 'PUSH',
}

export enum WithdrawalReportType {
  ForInitializeUser = 'FOR_INITIALIZE_USER',
  ForPrivacy = 'FOR_PRIVACY',
  NotInterested = 'NOT_INTERESTED',
  Etc = 'ETC',
}

export enum TokenIssuer {
  Google = 'GOOGLE',
  Kakao = 'KAKAO',
  Facebook = 'FACEBOOK',
  Line = 'LINE',
  Apple = 'APPLE',
}

export enum ReportType {
  Sexual = 'SEXUAL',
  GroupHatred = 'GROUP_HATRED',
  Violence = 'VIOLENCE',
  Disgusting = 'DISGUSTING',
  IntellectualProperty = 'INTELLECTUAL_PROPERTY',
  Rumor = 'RUMOR',
  SelfInjury = 'SELF_INJURY',
  Privacy = 'PRIVACY',
  Spam = 'SPAM',
  Etc = 'ETC',
}

export enum RateGeneratedCharacterImageRequestReact {
  Like = 'LIKE',
  Dislike = 'DISLIKE',
  Cancel = 'CANCEL',
}

export enum ReportBackgroundImageRequestType {
  Sexual = 'SEXUAL',
  Violence = 'VIOLENCE',
  ChildAbuse = 'CHILD_ABUSE',
  Discrimination = 'DISCRIMINATION',
  Disgusting = 'DISGUSTING',
  Quality = 'QUALITY',
}

export enum ReportCharacterProfileImageGenerationResultRequestType {
  Sexual = 'SEXUAL',
  Violence = 'VIOLENCE',
  ChildAbuse = 'CHILD_ABUSE',
  Discrimination = 'DISCRIMINATION',
  Disgusting = 'DISGUSTING',
  Quality = 'QUALITY',
}

export enum ContactStatus {
  Pending = 'PENDING',
  PendingChild = 'PENDING_CHILD',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Closed = 'CLOSED',
}

export enum BlockReasonType {
  CopyrightInner = 'COPYRIGHT_INNER',
  CopyrightOuter = 'COPYRIGHT_OUTER',
  Monitoring = 'MONITORING',
  Community = 'COMMUNITY',
  UserProfile = 'USER_PROFILE',
  Other = 'OTHER',
}

export enum BlockType {
  BlockAll = 'BLOCK_ALL',
  BlockCreatePlot = 'BLOCK_CREATE_PLOT',
}

export enum PenaltyLevel {
  Info = 'INFO',
  Warning = 'WARNING',
  Block = 'BLOCK',
}

export enum UserProfileField {
  ProfileImage = 'PROFILE_IMAGE',
  Description = 'DESCRIPTION',
}

export enum UserProfilePenaltyType {
  AbusedImage = 'ABUSED_IMAGE',
  Sexual = 'SEXUAL',
  GroupHatred = 'GROUP_HATRED',
  Privacy = 'PRIVACY',
  Spam = 'SPAM',
  Etc = 'ETC',
}

export enum PolicyType {
  Privacy = 'PRIVACY',
  Terms = 'TERMS',
  PrivacyAgreement = 'PRIVACY_AGREEMENT',
}

export enum PlotImageMonitoringAction {
  Release = 'RELEASE',
  Filtered = 'FILTERED',
  HardDeleted = 'HARD_DELETED',
  HardDeletedWithBlock = 'HARD_DELETED_WITH_BLOCK',
  ImageDeletedWithBlock = 'IMAGE_DELETED_WITH_BLOCK',
}

export enum ProductType {
  CoinBundle = 'COIN_BUNDLE',
  Package = 'PACKAGE',
}

export enum KeywordType {
  AbusingSearchKeyword = 'ABUSING_SEARCH_KEYWORD',
  AbusingSearchKeywordTopRanking = 'ABUSING_SEARCH_KEYWORD_TOP_RANKING',
  AbusingPlotPrompt = 'ABUSING_PLOT_PROMPT',
  AbusingPlotHashtag = 'ABUSING_PLOT_HASHTAG',
  AbusingUser = 'ABUSING_USER',
  AbusingChattingKeyword = 'ABUSING_CHATTING_KEYWORD',
  ForbiddenChattingKeyword = 'FORBIDDEN_CHATTING_KEYWORD',
  AbusingPromptKeywordForPlotMonitoring = 'ABUSING_PROMPT_KEYWORD_FOR_PLOT_MONITORING',
  WarnPlotNameKeyword = 'WARN_PLOT_NAME_KEYWORD',
}

export enum AdminCoinDepositType {
  InternalTest = 'INTERNAL_TEST',
  AdminReward = 'ADMIN_REWARD',
}

export enum CoinProductType {
  Pro = 'PRO',
  CharacterFacial = 'CHARACTER_FACIAL',
  CharacterVoice = 'CHARACTER_VOICE',
  SaveRoom = 'SAVE_ROOM',
  LoadRoom = 'LOAD_ROOM',
  SkipInterstitialAd = 'SKIP_INTERSTITIAL_AD',
  CharacterSkin = 'CHARACTER_SKIN',
  RecommendedMessage = 'RECOMMENDED_MESSAGE',
  CharacterProfileImageGeneration = 'CHARACTER_PROFILE_IMAGE_GENERATION',
}

export enum CharacterExpression {
  Laughing = 'LAUGHING',
  Embarrassed = 'EMBARRASSED',
  Friendly = 'FRIENDLY',
  Sad = 'SAD',
  Mischievous = 'MISCHIEVOUS',
  Serious = 'SERIOUS',
  Angry = 'ANGRY',
  Expressionless = 'EXPRESSIONLESS',
  Cry = 'CRY',
  Curious = 'CURIOUS',
  무표정한얼굴로 = '무표정한_얼굴로',
  차가운눈빛으로 = '차가운_눈빛으로',
  미간을찌푸리며 = '미간을_찌푸리며',
  의심의눈초리로 = '의심의_눈초리로',
  화를내며 = '화를_내며',
  미소를지으며 = '미소를_지으며',
  웃으며 = '웃으며',
  짓궂은표정으로 = '짓궂은_표정으로',
  비웃듯이 = '비웃듯이',
  능글맞은표정으로 = '능글맞은_표정으로',
  씨익웃으며 = '씨익_웃으며',
  장난기어린표정으로 = '장난기_어린_표정으로',
  기뻐하며 = '기뻐하며',
  애절한눈빛으로 = '애절한_눈빛으로',
  시무룩한얼굴로 = '시무룩한_얼굴로',
  속상한표정으로 = '속상한_표정으로',
  눈물을글썽이며 = '눈물을_글썽이며',
  눈물을흘리며 = '눈물을_흘리며',
  울음을터뜨리며 = '울음을_터뜨리며',
  깜짝놀라며 = '깜짝_놀라며',
  겁에질린얼굴로 = '겁에_질린_얼굴로',
  당황한표정으로 = '당황한_표정으로',
  쑥스러워하며 = '쑥스러워하며',
  얼굴을붉히며 = '얼굴을_붉히며',
}

export enum PushType {
  NewUser = 'NEW_USER',
  OldUser = 'OLD_USER',
  JapanOncePush = 'JAPAN_ONCE_PUSH',
  ZetaBotPush = 'ZETA_BOT_PUSH',
  NextDay = 'NEXT_DAY',
  CreatorFollow = 'CREATOR_FOLLOW',
  FollowNewPlot = 'FOLLOW_NEW_PLOT',
  InvitationReward = 'INVITATION_REWARD',
  InvitationSignUp = 'INVITATION_SIGN_UP',
  Announcement = 'ANNOUNCEMENT',
  NewRecommendPlot = 'NEW_RECOMMEND_PLOT',
  StoryPublish = 'STORY_PUBLISH',
  StoryViewCount = 'STORY_VIEW_COUNT',
}

export enum UpdatePlotStatusRequestStatus {
  Release = 'RELEASE',
  Delete = 'DELETE',
}

export enum ExceptionCode {
  NotFound = 'NOT_FOUND',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  Forbidden = 'FORBIDDEN',
  BadRequest = 'BAD_REQUEST',
  MethodNotAllowed = 'METHOD_NOT_ALLOWED',
  TooManyRequest = 'TOO_MANY_REQUEST',
  Conflict = 'CONFLICT',
  PreconditionFailed = 'PRECONDITION_FAILED',
  Unauthorized = 'UNAUTHORIZED',
  AuthExpired = 'AUTH_EXPIRED',
  AuthInvalidUser = 'AUTH_INVALID_USER',
  AnonymousNotAllowed = 'ANONYMOUS_NOT_ALLOWED',
  LayoutNotFound = 'LAYOUT_NOT_FOUND',
  UsernameAlreadyExists = 'USERNAME_ALREADY_EXISTS',
  UserBanned = 'USER_BANNED',
  AbusedUserInfo = 'ABUSED_USER_INFO',
  BlockedUser = 'BLOCKED_USER',
  UserAbusedProfileImage = 'USER_ABUSED_PROFILE_IMAGE',
  UserChatProfileMinimumLimit = 'USER_CHAT_PROFILE_MINIMUM_LIMIT',
  UserChatProfileMaximumLimit = 'USER_CHAT_PROFILE_MAXIMUM_LIMIT',
  UserChatProfileSelectedAlreadyExists = 'USER_CHAT_PROFILE_SELECTED_ALREADY_EXISTS',
  UserChatProfileSelectedRequired = 'USER_CHAT_PROFILE_SELECTED_REQUIRED',
  UserChatProfileAbused = 'USER_CHAT_PROFILE_ABUSED',
  UserAbusedChatProfileImage = 'USER_ABUSED_CHAT_PROFILE_IMAGE',
  PlotIsNotCompleted = 'PLOT_IS_NOT_COMPLETED',
  PlotNameConstraintViolation = 'PLOT_NAME_CONSTRAINT_VIOLATION',
  PlotShortDescriptionConstraintViolation = 'PLOT_SHORT_DESCRIPTION_CONSTRAINT_VIOLATION',
  PlotCharacterImageConstraintViolation = 'PLOT_CHARACTER_IMAGE_CONSTRAINT_VIOLATION',
  PlotCharacterConstraintViolation = 'PLOT_CHARACTER_CONSTRAINT_VIOLATION',
  PlotCharacterNameDuplicateConstraintViolation = 'PLOT_CHARACTER_NAME_DUPLICATE_CONSTRAINT_VIOLATION',
  PlotContentConstraintViolation = 'PLOT_CONTENT_CONSTRAINT_VIOLATION',
  PlotIntroConstraintViolation = 'PLOT_INTRO_CONSTRAINT_VIOLATION',
  PlotExampleConversationConstraintViolation = 'PLOT_EXAMPLE_CONVERSATION_CONSTRAINT_VIOLATION',
  PlotCreatorCommentConstraintViolation = 'PLOT_CREATOR_COMMENT_CONSTRAINT_VIOLATION',
  PlotAbusedName = 'PLOT_ABUSED_NAME',
  PlotAbusedIntro = 'PLOT_ABUSED_INTRO',
  PlotAbusedShortDescription = 'PLOT_ABUSED_SHORT_DESCRIPTION',
  PlotAbusedLongDescription = 'PLOT_ABUSED_LONG_DESCRIPTION',
  PlotAbusedCharacterName = 'PLOT_ABUSED_CHARACTER_NAME',
  PlotAbusedCharacterDescription = 'PLOT_ABUSED_CHARACTER_DESCRIPTION',
  PlotAbusedProfileImage = 'PLOT_ABUSED_PROFILE_IMAGE',
  PlotAbusedHashtag = 'PLOT_ABUSED_HASHTAG',
  PlotAbusedCreatorComment = 'PLOT_ABUSED_CREATOR_COMMENT',
  CannotBlockMyPlot = 'CANNOT_BLOCK_MY_PLOT',
  RoomAccessDenied = 'ROOM_ACCESS_DENIED',
  RoomNotActive = 'ROOM_NOT_ACTIVE',
  RoomNotSaved = 'ROOM_NOT_SAVED',
  SaveRoomLimitExceeded = 'SAVE_ROOM_LIMIT_EXCEEDED',
  PinRoomLimitExceeded = 'PIN_ROOM_LIMIT_EXCEEDED',
  RoomEmptyError = 'ROOM_EMPTY_ERROR',
  AbusedSearchKeyword = 'ABUSED_SEARCH_KEYWORD',
  AnonymousLimitExceeded = 'ANONYMOUS_LIMIT_EXCEEDED',
  ServiceMaintenance = 'SERVICE_MAINTENANCE',
  AppUpdateRequired = 'APP_UPDATE_REQUIRED',
  AlreadyCreatedNuttyUser = 'ALREADY_CREATED_NUTTY_USER',
  ChatEditAbused = 'CHAT_EDIT_ABUSED',
  ChatRecommendAbused = 'CHAT_RECOMMEND_ABUSED',
  PushMessageAbused = 'PUSH_MESSAGE_ABUSED',
  ProRequired = 'PRO_REQUIRED',
  NotEnoughCoin = 'NOT_ENOUGH_COIN',
  AlreadyConsumed = 'ALREADY_CONSUMED',
  TextForVoiceEmpty = 'TEXT_FOR_VOICE_EMPTY',
  TextLengthForVoiceExceeded = 'TEXT_LENGTH_FOR_VOICE_EXCEEDED',
  RecommendMessageNotReady = 'RECOMMEND_MESSAGE_NOT_READY',
  RecommendMessageAlreadyAvailable = 'RECOMMEND_MESSAGE_ALREADY_AVAILABLE',
  RecommendMessageAbusedBefore = 'RECOMMEND_MESSAGE_ABUSED_BEFORE',
  RecommendMessageAbusing = 'RECOMMEND_MESSAGE_ABUSING',
  NotFoundCoinSubscribeListener = 'NOT_FOUND_COIN_SUBSCRIBE_LISTENER',
  ConversationsEmpty = 'CONVERSATIONS_EMPTY',
  ConversationsLastEmpty = 'CONVERSATIONS_LAST_EMPTY',
  MemoryIsBeingCreating = 'MEMORY_IS_BEING_CREATING',
}

export enum StoryOrderBy {
  Recommended = 'RECOMMENDED',
  ViewCount = 'VIEW_COUNT',
  Updated = 'UPDATED',
  Latest = 'LATEST',
}

export enum RoomOrderByProperty {
  LastMessageTime = 'LAST_MESSAGE_TIME',
}

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum MessageBackgroundStatus {
  Generating = 'GENERATING',
  Generated = 'GENERATED',
}

export enum PlotOrderByProperty {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  ReleasedAt = 'RELEASED_AT',
  InteractionCount = 'INTERACTION_COUNT',
  InteractionCountWithRegen = 'INTERACTION_COUNT_WITH_REGEN',
}

export enum PlotSearchOrder {
  Latest = 'LATEST',
  Recommended = 'RECOMMENDED',
}

export enum PlotSearchSource {
  PlotCard = 'PLOT_CARD',
  PlotProfile = 'PLOT_PROFILE',
  AutoComplete = 'AUTO_COMPLETE',
  Recommend = 'RECOMMEND',
  Recent = 'RECENT',
}

export enum RankingType {
  RealtimeRerank = 'REALTIME_RERANK',
  Realtime = 'REALTIME',
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
}

export enum RankingGender {
  Male = 'MALE',
  Female = 'FEMALE',
  All = 'ALL',
}

export enum RankingFilterType {
  Hashtag = 'HASHTAG',
  RecentReleaseDays = 'RECENT_RELEASE_DAYS',
}

export enum OpenStoreProductApiDtoType {
  InApp = 'IN_APP',
  Subscription = 'SUBSCRIPTION',
}

export enum ZetaReportType {
  General = 'GENERAL',
  UserProfile = 'USER_PROFILE',
  Story = 'STORY',
}

export enum PurchaseStatus {
  Requested = 'REQUESTED',
  Charged = 'CHARGED',
  Refunded = 'REFUNDED',
}

export enum PlotLifecycleRank {
  S = 'S',
  A = 'A',
  N = 'N',
  F = 'F',
}

export enum RiskGroup {
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW',
  RealImage = 'REAL_IMAGE',
}

export enum PlotImageGender {
  Male = 'MALE',
  Female = 'FEMALE',
  Unknown = 'UNKNOWN',
}

export enum PlotImageSexual {
  Sexy = 'SEXY',
  Neutral = 'NEUTRAL',
  Porn = 'PORN',
}

export enum PlotImageStyle {
  Realistic = 'REALISTIC',
  Illustration = 'ILLUSTRATION',
}

export enum OpenStorePurchasePhaseAdminApiDtoStatus {
  Charged = 'CHARGED',
  Refunded = 'REFUNDED',
}

export class PutMessageRequest {
  type!: 'CONTENT' | 'CANDIDATE';
}

export class MessageApiDtoContentApiDto {
  type!: 'TEXT';
}

export class PutCharacterVoiceSettingApiDto {
  type!: 'Disable' | 'Enable';
}

export class ClickAction {
  type!: 'proPurchaseModal' | 'externalLink' | 'navigate' | 'eventModal';
}

export class LayoutSectionContentApiDto {
  type!:
    | 'PlotId'
    | 'PlotIdAndReply'
    | 'RecentlyPopular'
    | 'RecentlyCreated'
    | 'CollaborativeFiltering'
    | 'RelatedPlot'
    | 'DiscoveryRecommended'
    | 'PlotPool'
    | 'PlotLifecyclePoolHighQuality'
    | 'PlotLifecycleRandom';
}

export class LayoutSectionDisplayApiDto {
  type!:
    | 'BigProfile'
    | 'SmallProfile'
    | 'RecommendedReply'
    | 'Ranking'
    | 'RecentlyCreatedWithMoreView'
    | 'TiktokEvent'
    | 'PlotPoolMoreView'
    | 'DiscoveryRecommendedRefreshView';
}

export class ChatMABExperimentDistribution {
  ratio!: number;
  type!: 'normal' | 'exponential';
}

export class MABPrerequisite {
  type!: 'SeedRange' | 'Gender';
}

export class ExperimentMetadataCharacterRecommendationRecommendType {
  type!: 'collaborativeFiltering' | 'google';
}

export class ExperimentMetadataSimilarCharacterRecommendationRecommendType {
  type!: 'collaborativeFiltering' | 'google';
}

export class ChatStreamApiDto {
  event!:
    | 'IN_PROGRESS'
    | 'DETECT_SCENE'
    | 'CHANGE_FACIAL'
    | 'CHAT_COMPLETE'
    | 'CANDIDATE_COMPLETE'
    | 'EXAMPLE_CHAT_COMPLETE'
    | 'ERROR'
    | 'DETECT_ABUSING';
}

export class SendMessageAndReceiveStreamRequest {
  type!: 'TEXT';
}

export class OpenApiChatResponse {
  type!: 'IN_PROGRESS' | 'COMPLETE' | 'ERROR' | 'ABUSING_DETECTED';
}

export class IssueTokenRequest {
  deviceId!: string;
  type!: 'anonymous' | 'refresh' | 'external' | 'secretCode';
}

export class UserBlockRequest {
  reason?: string;
  blockType!: BlockType;
  reasonType?: BlockReasonType;
  type!: 'PERMANENT' | 'TEMPORARY';
}

export class AdminSearchBooleanCondition {
  type!: 'booleanIs' | 'booleanIsNull' | 'booleanIsNotNull';
}

export class AdminSearchConditionSort {
  type!: 'asc' | 'desc';
}

export class AdminSearchDateCondition {
  type!: 'dateAt' | 'dateRange' | 'dateIsNull' | 'dateIsNotNull';
}

export class AdminSearchStringCondition {
  type!:
    | 'stringExact'
    | 'stringInclude'
    | 'stringStarts'
    | 'stringEnds'
    | 'stringIn'
    | 'stringNotIn'
    | 'stringIsNull'
    | 'stringIsNotNull';
}

export class AdminSearchNumberCondition {
  type!: 'numberEqual' | 'numberRange' | 'numberIsNull' | 'numberIsNotNull';
}

export class BlockedPlotApiDto {
  plotId!: string;
  type!: 'deleted' | 'active';
}

export class RenderedLayoutSectionApiDto {
  id!: string;
  @Type(() => Date)
  updatedAt!: Date;
  type!:
    | 'BigProfile'
    | 'SmallProfile'
    | 'RecommendedReply'
    | 'Ranking'
    | 'RecentlyCreatedWithMoreView'
    | 'PlotPoolMoreView'
    | 'DiscoveryRecommendedRefreshView';
}

export class VoiceSettingApiDto {
  genderValue?: number;
  ageValue?: number;
  pitchShift!: number;
  pitchVariance!: number;
  speed!: number;
}

export class CharacterVoiceSettingApiDto {
  templateId!: string;
  @Type(() => VoiceSettingApiDto)
  setting!: VoiceSettingApiDto;
  enabled!: boolean;
}

export class SampleVoiceResponse {
  audioUrls!: string[];
}

export class AreaCoordinates {
  minX!: number;
  minY!: number;
  maxX!: number;
  maxY!: number;
}

export class UpdateUserProfileImageRequest {
  image!: Blob;
  @Type(() => AreaCoordinates)
  cropCoordinates!: AreaCoordinates;
}

export class UpdateUserProfileImageResponse {
  imageUrl!: string;
}

export class SelectUserChatProfileRequest {
  plotId!: string;
}

export class UserChatProfileSettingApiDto {
  isActive!: boolean;
}

export class UpdateStoryFavoritePushRequest {
  isPushAllowed!: boolean;
}

export class UpdateRoomRequest {
  title?: string;
}

export class Candidate extends PutMessageRequest {
  declare type: 'CANDIDATE';
  candidateId!: string;
}

export class PutMessageRequestTextApiDto {
  text!: string;
}

export class Content extends PutMessageRequest {
  declare type: 'CONTENT';
  @Type(() => PutMessageRequestTextApiDto)
  content!: PutMessageRequestTextApiDto;
  requestId!: string;
}

export class MessageApiDtoSender {
  id!: string;
  type!: SenderType;
}

export class MessageApiDtoTextApiDto extends MessageApiDtoContentApiDto {
  declare type: 'TEXT';
  speakerName?: string;
  position?: SpeakerPosition;
  /**
   * @example 안녕하세요
   */
  text!: string;
}

export class MessageVoiceApiDto {
  url!: string;
  durationSeconds!: number;
}

export class MessageApiDto {
  id!: string;
  roomId!: string;
  @Type(() => MessageApiDtoSender)
  sender!: MessageApiDtoSender;
  @Type(() => MessageApiDtoContentApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [{ value: MessageApiDtoTextApiDto, name: 'TEXT' }],
    },
    keepDiscriminatorProperty: true,
  })
  contents!: MessageApiDtoTextApiDto[];
  @Type(() => MessageVoiceApiDto)
  voice?: MessageVoiceApiDto;
  edited!: boolean;
  candidateId?: string;
  @Type(() => Date)
  messageTime!: Date;
  voicePrice?: number;
  isIntro!: boolean;
}

export class PutMessageResponse {
  @Type(() => MessageApiDto)
  message!: MessageApiDto;
}

export class UpdateCandidateRequest {
  requestId!: string;
  @Type(() => MessageApiDtoContentApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [{ value: MessageApiDtoTextApiDto, name: 'TEXT' }],
    },
    keepDiscriminatorProperty: true,
  })
  contents?: MessageApiDtoTextApiDto[];
  text?: string;
}

export class UpdateCandidateResponse {
  id!: string;
  @Type(() => MessageApiDtoContentApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [{ value: MessageApiDtoTextApiDto, name: 'TEXT' }],
    },
    keepDiscriminatorProperty: true,
  })
  contents!: MessageApiDtoTextApiDto[];
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  messageTime!: Date;
  edited!: boolean;
  sceneDetected!: boolean;
  facialImageUrl?: string;
  @Type(() => MessageVoiceApiDto)
  voice?: MessageVoiceApiDto;
}

export class ConversationApiDtoMessageApiDto {
  content!: string;
  senderType!: SenderType;
}

export class ConversationApiDto {
  @Type(() => ConversationApiDtoMessageApiDto)
  messages?: ConversationApiDtoMessageApiDto[];
}

export class ExampleConversationApiDtoMessageDto {
  sender!: SenderType;
  content!: string;
}

export class ExampleConversationApiDto {
  @Type(() => ExampleConversationApiDtoMessageDto)
  messages!: ExampleConversationApiDtoMessageDto[];
  randomUsername?: string;
}

export class PlotIntroDraftApiDto {
  @Type(() => ConversationApiDto)
  conversation!: ConversationApiDto;
  publicConversationMessageCount?: number;
}

export class UpdatePlotCharacterApiDto {
  id?: string;
  name?: string;
  description?: string;
  imageUrl?: string;
}

export class UpdatePlotApiDto {
  name!: string;
  initialRoomImageUrl?: string;
  shortDescription!: string;
  longDescription!: string;
  @Type(() => UpdatePlotCharacterApiDto)
  characters!: UpdatePlotCharacterApiDto[];
  @Type(() => ExampleConversationApiDto)
  exampleConversations!: ExampleConversationApiDto[];
  isLongDescriptionPublic!: boolean;
  isExampleConversationPublic!: boolean;
  @Type(() => PlotIntroDraftApiDto)
  intros!: PlotIntroDraftApiDto[];
  hashtags!: string[];
  autoGenerateBackgroundImage!: boolean;
  creatorComment!: string;
}

export class PlotCharacterApiDto {
  id!: string;
  plotId!: string;
  name!: string;
  description?: string;
  imageUrl?: string;
  isProfileImageDeletedByAbusing!: boolean;
}

export class PlotCharacterDraftApiDto {
  id!: string;
  name?: string;
  description?: string;
  imageUrl?: string;
}

export class PlotCreatorForCreatorApiDto {
  id!: string;
  /**
   * @example dafunk
   */
  nickname!: string;
  /**
   * @example dafunk
   */
  username!: string;
  /**
   * @example https://avatars.githubusercontent.com/u/12345678?v=4
   */
  profileImageUrl?: string;
  isActive!: boolean;
}

export class PlotDraftApiDto {
  name?: string;
  initialRoomImageUrl?: string;
  shortDescription?: string;
  longDescription?: string;
  @Type(() => PlotCharacterDraftApiDto)
  characters!: PlotCharacterDraftApiDto[];
  @Type(() => ExampleConversationApiDto)
  exampleConversation!: ExampleConversationApiDto[];
  isLongDescriptionPublic!: boolean;
  isExampleConversationPublic!: boolean;
  @Type(() => PlotIntroDraftApiDto)
  intros?: PlotIntroDraftApiDto[];
  hashtags!: string[];
  creatorComment?: string;
}

export class PlotIntroApiDto {
  @Type(() => ConversationApiDto)
  conversation!: ConversationApiDto;
  publicConversationMessageCount!: number;
}

export class PlotForCreatorApiDto {
  id!: string;
  /**
   * @example 이루다
   */
  name?: string;
  initialRoomImageUrl?: string;
  /**
   * 캐릭터 설명
   */
  shortDescription?: string;
  /**
   * 상세 설명
   */
  longDescription?: string;
  @Type(() => PlotCharacterApiDto)
  characters!: PlotCharacterApiDto[];
  /**
   * 예시 대화
   */
  @Type(() => ExampleConversationApiDto)
  conversations?: ExampleConversationApiDto[];
  @Type(() => PlotIntroApiDto)
  intros?: PlotIntroApiDto[];
  isLongDescriptionPublic!: boolean;
  isExampleConversationPublic!: boolean;
  status!: PlotStatus;
  country!: Country;
  interactionCount!: number;
  interactionCountWithRegen!: number;
  voicePlaySeconds!: number;
  verified!: boolean;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  releasedAt?: Date;
  @Type(() => Date)
  updatedAt!: Date;
  @Type(() => PlotCreatorForCreatorApiDto)
  creator!: PlotCreatorForCreatorApiDto;
  creatorComment?: string;
  hashtags!: string[];
  @Type(() => PlotDraftApiDto)
  draft?: PlotDraftApiDto;
  autoGenerateBackgroundImage!: boolean;
  isPrivate!: boolean;
  isLocked!: boolean;
  isLiked!: boolean;
  originatedId?: string;
  supportedFeatures!: PlotFeature[];
  locked?: boolean;
}

export class PutCharacterVoiceSettingApiDtoDisable extends PutCharacterVoiceSettingApiDto {
  declare type: 'Disable';
}

export class PutCharacterVoiceSettingApiDtoEnable extends PutCharacterVoiceSettingApiDto {
  declare type: 'Enable';
  templateId!: string;
  @Type(() => VoiceSettingApiDto)
  setting!: VoiceSettingApiDto;
}

export class UpdatePlotImageRequest {
  imageUrl?: string;
  image?: Blob[];
  @Type(() => AreaCoordinates)
  cropCoordinates!: AreaCoordinates;
  profileImageResultId?: string;
}

export class UpdatePlotImageResponse {
  imageUrl!: string;
  @Type(() => Date)
  updatedAt!: Date;
}

export class PurchaseBulkRequestPurchaseInfo {
  /**
   * 스토어 상품 ID
   */
  id!: string;
  /**
   * 스토어 결제 트랜잭션 ID
   */
  token!: string;
}

export class PurchaseBulkRequest {
  @Type(() => PurchaseBulkRequestPurchaseInfo)
  purchases!: PurchaseBulkRequestPurchaseInfo[];
}

export class PutCharacterSkinSettingRequest {
  selectedId?: string;
  enabled!: boolean;
}

export class CharacterSkinSettingApiDto {
  selectedId?: string;
  enabled!: boolean;
}

export class UpdateAppPushTokenRequest {
  deviceType!: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  deviceId!: string;
  token!: string;
}

export class UpdateAppPushSettingRequest {
  isEnabled!: boolean;
}

export class PutVoiceTemplateApiDto {
  supertoneId!: string;
  name!: string;
  gender!: Gender;
  ageGroup!: VoiceAgeGroup;
  genderValue?: number;
  ageValue?: number;
  pitchShift!: number;
  pitchVariance!: number;
  speed!: number;
  tagIds!: number[];
}

export class PutVoiceTemplateTagApiDto {
  text!: string;
  color!: string;
}

export class UpdateUserReportStatusAdminRequest {
  status!: ReportStatus;
}

export class UpdateSupportCategoryAdminRequest {
  name!: string;
  description?: string;
  sequence!: number;
  type!: SupportCategoryType;
}

export class SupportCategoryAdminApiDto {
  id!: string;
  parentCategoryId?: string;
  name!: string;
  description?: string;
  sequence!: number;
  type!: SupportCategoryType;
}

export class UpdateStoryByAdminRequest {
  title!: string;
  description!: string;
  coverImageUrl!: string;
}

export class PutStoryStatusByAdminRequest {
  status!: StoryStatus;
}

export class UpdateStoryEpisodeByAdminRequest {
  title!: string;
  description?: string;
}

export class UpdateEpisodeStatusByAdminRequest {
  status!: StoryEpisodeStatus;
}

export class UpdateEpisodeScheduledPublishDateByAdminRequest {
  scheduledPublishDate!: string;
}

export class JsonNode {}

export class EventModal extends ClickAction {
  declare type: 'eventModal';
  eventName!: string;
}

export class ExternalLink extends ClickAction {
  declare type: 'externalLink';
  url!: string;
}

export class Navigate extends ClickAction {
  declare type: 'navigate';
  href!: string;
  routeName!: string;
  routeParams!: object;
}

export class ProPurchaseModal extends ClickAction {
  declare type: 'proPurchaseModal';
  nudgeType!: NudgeType;
}

export class TargetABExperimentApiDto {
  experimentId!: string;
  buckets!: string[];
}

export class CreateOrUpdatePopupRequest {
  country!: Country;
  imageUrl!: string;
  isActive!: boolean;
  isProOnly!: boolean;
  @Type(() => ClickAction, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: ProPurchaseModal, name: 'proPurchaseModal' },
        { value: ExternalLink, name: 'externalLink' },
        { value: Navigate, name: 'navigate' },
        { value: EventModal, name: 'eventModal' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  clickAction!: EventModal | ExternalLink | Navigate | ProPurchaseModal;
  minimumAppVersion?: string;
  @Type(() => TargetABExperimentApiDto)
  targetABExperiment?: TargetABExperimentApiDto;
}

export class UpdatePlotVerifiedAdminRequest {
  verified!: boolean;
}

export class Draft {
  name?: string;
  initialRoomImageUrl?: string;
  shortDescription?: string;
  longDescription?: string;
  @Type(() => PlotCharacterDraftApiDto)
  characters!: PlotCharacterDraftApiDto[];
  @Type(() => ExampleConversationApiDto)
  exampleConversation!: ExampleConversationApiDto[];
  isLongDescriptionPublic!: boolean;
  isExampleConversationPublic!: boolean;
  greeting?: string;
  @Type(() => PlotIntroDraftApiDto)
  intros?: PlotIntroDraftApiDto[];
  hashtags!: string[];
  creatorComment?: string;
}

export class PlotForCreatorAdminApiDto {
  id!: string;
  /**
   * @example 이루다
   */
  name?: string;
  initialRoomImageUrl?: string;
  /**
   * 캐릭터 설명
   */
  shortDescription?: string;
  /**
   * 상세 설명
   */
  longDescription?: string;
  @Type(() => PlotCharacterApiDto)
  characters!: PlotCharacterApiDto[];
  /**
   * 예시 대화
   */
  @Type(() => ExampleConversationApiDto)
  conversations?: ExampleConversationApiDto[];
  @Type(() => PlotIntroApiDto)
  intros?: PlotIntroApiDto[];
  isLongDescriptionPublic!: boolean;
  isExampleConversationPublic!: boolean;
  status!: PlotStatus;
  country!: Country;
  interactionCount!: number;
  interactionCountWithRegen!: number;
  verified!: boolean;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  releasedAt?: Date;
  @Type(() => Date)
  updatedAt!: Date;
  @Type(() => PlotCreatorForCreatorApiDto)
  creator!: PlotCreatorForCreatorApiDto;
  creatorComment?: string;
  hashtags!: string[];
  @Type(() => Draft)
  draft?: Draft;
  autoGenerateBackgroundImage!: boolean;
  isPrivate!: boolean;
  isLocked!: boolean;
  isLiked!: boolean;
  originatedId?: string;
  supportedFeatures!: PlotFeature[];
  locked?: boolean;
}

export class UpdatePlotStatusAdminRequest {
  stage?: 'PROFILE_IMAGE' | 'PROMPT';
  status!: PlotStatus;
  shouldBlockOnHardDeleted!: boolean;
}

export class UpdatePlotReportStatusAdminRequest {
  status!: ReportStatus;
}

export class UpdatePlotPoolAdminRequest {
  name!: string;
  description!: string;
}

export class PlotPoolAdminApiDto {
  id!: string;
  name!: string;
  description!: string;
  country!: Country;
  @Type(() => Date)
  createdAt!: Date;
}

export class CreateOrUpdatePlotLifecyclePoolAdminRequest {
  name!: string;
  description!: string;
  maxSize!: number;
}

export class PlotLifecyclePoolAdminApiDto {
  id!: string;
  name!: string;
  description!: string;
  country!: Country;
  maxSize!: number;
  @Type(() => Date)
  createdAt!: Date;
}

export class PutOpenStoreProductStatusRequest {
  status!: ProductStatus;
}

export class PutApiUserRequest {
  name!: string;
  rps!: number;
  isActive!: boolean;
}

export class UpdateButton {
  text!: string;
  link!: string;
}

export class ForceUpdateInfo {
  title!: string;
  body!: string;
  @Type(() => UpdateButton)
  updateButton!: UpdateButton;
}

export class UpdateMinimumAppVersionRequest {
  deviceType!: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  version!: string;
  country!: Country;
  @Type(() => ForceUpdateInfo)
  forceUpdateInfo!: ForceUpdateInfo;
}

export class MinimumAppVersionApiDto {
  deviceType!: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  version!: string;
  country!: Country;
  @Type(() => Date)
  updatedAt!: Date;
}

export class UpdateMaintenanceRequest {
  country!: Country;
  type!: 'EMERGENCY' | 'TEMPORARY';
  description!: string;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt?: Date;
}

export class MaintenanceApiDto {
  id!: number;
  country!: Country;
  type!: 'EMERGENCY' | 'TEMPORARY';
  description!: string;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt?: Date;
}

export class LayoutApiDtoFilter {
  target!: string;
  field!: string;
  operator!: Operator;
  value!: string;
}

export class UpdateLayoutRequest {
  name!: string;
  priority!: number;
  sectionIds!: string[];
  @Type(() => LayoutApiDtoFilter)
  filters!: LayoutApiDtoFilter[];
}

export class LayoutWithSectionIdApiDto {
  id!: string;
  name!: string;
  sectionIds!: string[];
  @Type(() => LayoutApiDtoFilter)
  filters!: LayoutApiDtoFilter[];
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class BigProfile extends LayoutSectionDisplayApiDto {
  declare type: 'BigProfile';
  title!: string;
  subtitle?: string;
  highlightText?: string;
}

export class CollaborativeFiltering extends LayoutSectionContentApiDto {
  declare type: 'CollaborativeFiltering';
}

export class DiscoveryRecommended extends LayoutSectionContentApiDto {
  declare type: 'DiscoveryRecommended';
}

export class LayoutSectionDisplayApiDtoDiscoveryRecommendedRefreshView extends LayoutSectionDisplayApiDto {
  declare type: 'DiscoveryRecommendedRefreshView';
  title!: string;
  subtitle?: string;
  highlightText?: string;
}

export class LayoutSectionDisplayApiDtoPlotPoolMoreView extends LayoutSectionDisplayApiDto {
  declare type: 'PlotPoolMoreView';
  title!: string;
  subtitle?: string;
  highlightText?: string;
}

export class LayoutSectionDisplayApiDtoTiktokEvent extends LayoutSectionDisplayApiDto {
  declare type: 'TiktokEvent';
  title!: string;
  subtitle?: string;
  highlightText?: string;
}

export class PlotId extends LayoutSectionContentApiDto {
  declare type: 'PlotId';
  plotIds!: string[];
}

export class PlotLifecyclePoolHighQuality extends LayoutSectionContentApiDto {
  declare type: 'PlotLifecyclePoolHighQuality';
  plotLifecyclePoolId!: string;
}

export class PlotLifecycleRandom extends LayoutSectionContentApiDto {
  declare type: 'PlotLifecycleRandom';
  plotLifecycleStage!: PlotLifecycleStage;
}

export class PlotPool extends LayoutSectionContentApiDto {
  declare type: 'PlotPool';
  plotPoolId!: string;
}

export class PlotReplies {
  plotId!: string;
  replies!: string[];
}

export class PlotIdAndReply extends LayoutSectionContentApiDto {
  declare type: 'PlotIdAndReply';
  @Type(() => PlotReplies)
  plots!: PlotReplies[];
}

export class Ranking extends LayoutSectionDisplayApiDto {
  declare type: 'Ranking';
  title!: string;
  subtitle?: string;
  highlightText?: string;
}

export class RecentlyCreated extends LayoutSectionContentApiDto {
  declare type: 'RecentlyCreated';
}

export class RecentlyCreatedWithMoreView extends LayoutSectionDisplayApiDto {
  declare type: 'RecentlyCreatedWithMoreView';
  title!: string;
  subtitle?: string;
  highlightText?: string;
}

export class RecentlyPopular extends LayoutSectionContentApiDto {
  declare type: 'RecentlyPopular';
}

export class RecommendedReply extends LayoutSectionDisplayApiDto {
  declare type: 'RecommendedReply';
  title!: string;
  subtitle?: string;
  highlightText?: string;
}

export class RelatedPlot extends LayoutSectionContentApiDto {
  declare type: 'RelatedPlot';
}

export class SmallProfile extends LayoutSectionDisplayApiDto {
  declare type: 'SmallProfile';
  title!: string;
  subtitle?: string;
  highlightText?: string;
}

export class UpdateLayoutSectionRequest {
  name!: string;
  @Type(() => LayoutSectionDisplayApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: BigProfile, name: 'BigProfile' },
        { value: SmallProfile, name: 'SmallProfile' },
        { value: RecommendedReply, name: 'RecommendedReply' },
        { value: Ranking, name: 'Ranking' },
        {
          value: RecentlyCreatedWithMoreView,
          name: 'RecentlyCreatedWithMoreView',
        },
        { value: LayoutSectionDisplayApiDtoTiktokEvent, name: 'TiktokEvent' },
        {
          value: LayoutSectionDisplayApiDtoPlotPoolMoreView,
          name: 'PlotPoolMoreView',
        },
        {
          value: LayoutSectionDisplayApiDtoDiscoveryRecommendedRefreshView,
          name: 'DiscoveryRecommendedRefreshView',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  display!:
    | BigProfile
    | LayoutSectionDisplayApiDtoDiscoveryRecommendedRefreshView
    | LayoutSectionDisplayApiDtoPlotPoolMoreView
    | LayoutSectionDisplayApiDtoTiktokEvent
    | Ranking
    | RecentlyCreatedWithMoreView
    | RecommendedReply
    | SmallProfile;
  @Type(() => LayoutSectionContentApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: PlotId, name: 'PlotId' },
        { value: PlotIdAndReply, name: 'PlotIdAndReply' },
        { value: RecentlyPopular, name: 'RecentlyPopular' },
        { value: RecentlyCreated, name: 'RecentlyCreated' },
        { value: CollaborativeFiltering, name: 'CollaborativeFiltering' },
        { value: RelatedPlot, name: 'RelatedPlot' },
        { value: DiscoveryRecommended, name: 'DiscoveryRecommended' },
        { value: PlotPool, name: 'PlotPool' },
        {
          value: PlotLifecyclePoolHighQuality,
          name: 'PlotLifecyclePoolHighQuality',
        },
        { value: PlotLifecycleRandom, name: 'PlotLifecycleRandom' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  content!:
    | CollaborativeFiltering
    | DiscoveryRecommended
    | PlotId
    | PlotIdAndReply
    | PlotLifecyclePoolHighQuality
    | PlotLifecycleRandom
    | PlotPool
    | RecentlyCreated
    | RecentlyPopular
    | RelatedPlot;
}

export class LayoutSectionApiDto {
  id!: string;
  name!: string;
  @Type(() => LayoutSectionDisplayApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: BigProfile, name: 'BigProfile' },
        { value: SmallProfile, name: 'SmallProfile' },
        { value: RecommendedReply, name: 'RecommendedReply' },
        { value: Ranking, name: 'Ranking' },
        {
          value: RecentlyCreatedWithMoreView,
          name: 'RecentlyCreatedWithMoreView',
        },
        { value: LayoutSectionDisplayApiDtoTiktokEvent, name: 'TiktokEvent' },
        {
          value: LayoutSectionDisplayApiDtoPlotPoolMoreView,
          name: 'PlotPoolMoreView',
        },
        {
          value: LayoutSectionDisplayApiDtoDiscoveryRecommendedRefreshView,
          name: 'DiscoveryRecommendedRefreshView',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  display!:
    | BigProfile
    | LayoutSectionDisplayApiDtoDiscoveryRecommendedRefreshView
    | LayoutSectionDisplayApiDtoPlotPoolMoreView
    | LayoutSectionDisplayApiDtoTiktokEvent
    | Ranking
    | RecentlyCreatedWithMoreView
    | RecommendedReply
    | SmallProfile;
  @Type(() => LayoutSectionContentApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: PlotId, name: 'PlotId' },
        { value: PlotIdAndReply, name: 'PlotIdAndReply' },
        { value: RecentlyPopular, name: 'RecentlyPopular' },
        { value: RecentlyCreated, name: 'RecentlyCreated' },
        { value: CollaborativeFiltering, name: 'CollaborativeFiltering' },
        { value: RelatedPlot, name: 'RelatedPlot' },
        { value: DiscoveryRecommended, name: 'DiscoveryRecommended' },
        { value: PlotPool, name: 'PlotPool' },
        {
          value: PlotLifecyclePoolHighQuality,
          name: 'PlotLifecyclePoolHighQuality',
        },
        { value: PlotLifecycleRandom, name: 'PlotLifecycleRandom' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  content!:
    | CollaborativeFiltering
    | DiscoveryRecommended
    | PlotId
    | PlotIdAndReply
    | PlotLifecyclePoolHighQuality
    | PlotLifecycleRandom
    | PlotPool
    | RecentlyCreated
    | RecentlyPopular
    | RelatedPlot;
}

export class PutInterstitialMetadataRequest {
  threshold!: number;
}

export class CreateOrUpdateFaqAdminRequest {
  mainCategoryId!: string;
  subCategoryId!: string;
  title!: string;
  content!: string;
  sequence!: number;
}

export class FaqAdminApiDto {
  id!: string;
  mainCategoryId!: string;
  subCategoryId!: string;
  title!: string;
  content!: string;
  sequence!: number;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class CreateOrUpdateFaqFavoriteAdminRequest {
  faqId!: string;
  sequence!: number;
}

export class FaqFavoriteAdminApiDto {
  faqId!: string;
  sequence!: number;
}

export class UpdateContactReplyRequest {
  content!: string;
  status!: ContactReplyStatus;
}

export class ContactReplyAdminApiDto {
  id!: string;
  contactId!: string;
  adminId?: string;
  content!: string;
  status!: ContactReplyStatus;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class CreateOrUpdateContactTemplateAdminRequest {
  mainCategoryId!: string;
  subCategoryId!: string;
  title!: string;
  content!: string;
}

export class ContactTemplateAdminApiDto {
  id!: string;
  mainCategoryId!: string;
  subCategoryId!: string;
  title!: string;
  content!: string;
}

export class CreateOrUpdateContactMemoAdminRequest {
  content!: string;
}

export class ContactMemoAdminApiDto {
  userId!: string;
  content!: string;
}

export class PutOpenCoinProductStatusRequest {
  status!: ProductStatus;
}

export class ChatMABConfig {
  distributionType!: DistributionType;
  updateIntervalMinutes!: number;
  credibleIntervalAlpha!: number;
  maxAllowedChange!: number;
  numSamplesToGenerate!: number;
}

export class ChatMABExperimentDistributionExponential extends ChatMABExperimentDistribution {
  declare type: 'exponential';
  sampleSize!: number;
  sumOfObservations!: number;
  priorShape!: number;
  priorRate!: number;
}

export class ChatMABExperimentDistributionNormal extends ChatMABExperimentDistribution {
  declare type: 'normal';
  sampleSize!: number;
  sumOfObservations!: number;
  squaredSumOfObservations!: number;
  priorSampleSize!: number;
  priorMean!: number;
  priorShape!: number;
  priorRate!: number;
}

export class Config {
  maxGeneratedTokens?: number;
  minGeneratedTokens?: number;
  maxSeqLen?: number;
  maxPromptSeqLen?: number;
  greedySearch?: boolean;
  topK?: number;
  topP?: number;
  repetitionPenalty?: number;
  noRepeatNgram?: number;
  numSequences?: number;
  temperature?: number;
  badWords?: string[];
}

export class GenderPrerequisite extends MABPrerequisite {
  declare type: 'Gender';
  gender!: Gender;
}

export class IntRange {
  start!: number;
  end!: number;
}

export class ExperimentMetadata {
  type!:
    | 'default'
    | 'model'
    | 'coinProduct'
    | 'openStoreProduct'
    | 'background'
    | 'interstitial'
    | 'regenCap'
    | 'slowChatNudge'
    | 'anonymousLimit'
    | 'characterFacialPrice'
    | 'calmWeb'
    | 'newTopic'
    | 'characterRecommendation'
    | 'similarCharacterRecommendation'
    | 'characterVoicePrice'
    | 'exitBanner'
    | 'abusingThreshold'
    | 'limit'
    | 'characterSkin'
    | 'quickReply'
    | 'characterProfileGenerationPrice'
    | 'onboardingCharacter'
    | 'mainLayout'
    | 'ranking';
  bucket!: string;
  @Type(() => IntRange)
  range!: IntRange;
}

export class MemoryConfig {
  isEnabled!: boolean;
  host!: string;
  contextSize!: number;
}

export class ChatMABExperimentModelConfig {
  speakerType?: ChatMABExperimentModelConfigSpeakerType;
  host?: string;
  proHost?: string;
  contextLength?: number;
  @Type(() => IntRange)
  contextLengthRange?: IntRange;
  probability!: number;
  modelType!: ChatMABExperimentModelConfigType;
  minimumLatencyMilliseconds?: number;
  @Type(() => Config)
  config?: Config;
  @Type(() => Config)
  regenConfig?: Config;
  @Type(() => MemoryConfig)
  memoryConfig?: MemoryConfig;
  shouldMultiSpeakerSupported?: boolean;
}

export class ChatMABExperimentBucket {
  bucket!: string;
  @Type(() => ChatMABExperimentModelConfig)
  modelConfig!: ChatMABExperimentModelConfig;
  @Type(() => ChatMABExperimentDistribution, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: ChatMABExperimentDistributionNormal, name: 'normal' },
        {
          value: ChatMABExperimentDistributionExponential,
          name: 'exponential',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  distribution!:
    | ChatMABExperimentDistributionExponential
    | ChatMABExperimentDistributionNormal;
}

export class SeedRangePrerequisite extends MABPrerequisite {
  declare type: 'SeedRange';
  seed!: string;
  @Type(() => IntRange)
  range!: IntRange;
}

export class UpdateChatMABExperimentRequest {
  @Type(() => IntRange)
  range!: IntRange;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt!: Date;
  description?: string;
  @Type(() => ChatMABConfig)
  config!: ChatMABConfig;
  @Type(() => ChatMABExperimentBucket)
  bucketList!: ChatMABExperimentBucket[];
  @Type(() => MABPrerequisite, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: SeedRangePrerequisite, name: 'SeedRange' },
        { value: GenderPrerequisite, name: 'Gender' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  prerequisites?: (GenderPrerequisite | SeedRangePrerequisite)[];
}

export class ChatMABExperimentAdminApiDto {
  id!: string;
  country!: Country;
  seed!: string;
  @Type(() => IntRange)
  range!: IntRange;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt!: Date;
  description?: string;
  @Type(() => ChatMABConfig)
  config!: ChatMABConfig;
  @Type(() => ChatMABExperimentBucket)
  bucketList!: ChatMABExperimentBucket[];
  @Type(() => Date)
  distributionUpdatedAt!: Date;
  @Type(() => MABPrerequisite, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: SeedRangePrerequisite, name: 'SeedRange' },
        { value: GenderPrerequisite, name: 'Gender' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  prerequisites?: (GenderPrerequisite | SeedRangePrerequisite)[];
}

export class PutCharacterSkinRequest {
  title!: string;
  imageUrl!: string;
  blurredImageUrl?: string;
  priority!: number;
}

export class CharacterSkinAdminApiDto {
  id!: string;
  characterId!: string;
  title!: string;
  imageUrl!: string;
  blurredImageUrl?: string;
  priority!: number;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class CreateOrUpdateBannerRequest {
  country!: Country;
  clientType!: 'APP' | 'WEB';
  titlePrimary!: string;
  titleSecondary!: string;
  imageUrl?: string;
  priority!: number;
  @Type(() => ClickAction, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: ProPurchaseModal, name: 'proPurchaseModal' },
        { value: ExternalLink, name: 'externalLink' },
        { value: Navigate, name: 'navigate' },
        { value: EventModal, name: 'eventModal' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  clickAction!: EventModal | ExternalLink | Navigate | ProPurchaseModal;
  isActive!: boolean;
  minimumAppVersion?: string;
  @Type(() => TargetABExperimentApiDto)
  targetABExperiment?: TargetABExperimentApiDto;
}

export class AnnouncementABExperimentConditionAdminApiDto {
  experimentId!: string;
  buckets!: string[];
}

export class AnnouncementWithoutIdAdminApiDto {
  title!: string;
  content!: string;
  country!: Country;
  publishedAt!: string;
  isDraft!: boolean;
  showBanner!: boolean;
  @Type(() => AnnouncementABExperimentConditionAdminApiDto)
  abExperimentIdBucketMap?: AnnouncementABExperimentConditionAdminApiDto[];
  targetDevice?: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  imageUrl?: string;
  minimumAppVersion?: string;
}

export class UpdateABUserRequest {
  experimentBucket!: string;
}

export class ABUserAdminApiDto {
  id!: number;
  userId!: string;
  experimentId!: string;
  experimentBucket!: string;
}

export class CharacterIdsByTargetGender {
  male!: string[];
  female!: string[];
}

export class CharacterProfileImageGenerationProduct extends ExperimentMetadata {
  declare type: 'characterProfileGenerationPrice';
  coinProductId?: string;
}

export class CharacterSkin extends ExperimentMetadata {
  declare type: 'characterSkin';
  previewAllowed!: boolean;
}

export class ExperimentMetadataAbusingThreshold extends ExperimentMetadata {
  declare type: 'abusingThreshold';
  threshold?: object;
}

export class ExperimentMetadataAnonymousLimit extends ExperimentMetadata {
  declare type: 'anonymousLimit';
  maxCandidateSize?: number;
  maxCharacterMessageSizeByRoomSize?: object;
}

export class ExperimentMetadataBackground extends ExperimentMetadata {
  declare type: 'background';
  isRetrieval!: boolean;
}

export class ExperimentMetadataCalmWeb extends ExperimentMetadata {
  declare type: 'calmWeb';
  thresholdInMilliseconds?: number;
  minimumLatencyMilliseconds?: number;
}

export class ExperimentMetadataCharacterFacialPrice extends ExperimentMetadata {
  declare type: 'characterFacialPrice';
  coinProductId!: object;
  previewCount?: number;
}

export class ExperimentMetadataCharacterRecommendation extends ExperimentMetadata {
  declare type: 'characterRecommendation';
  @Type(() => ExperimentMetadataCharacterRecommendationRecommendType)
  recommendType!: ExperimentMetadataCharacterRecommendationRecommendType;
}

export class ExperimentMetadataCharacterRecommendationRecommendTypeCollaborativeFiltering extends ExperimentMetadataCharacterRecommendationRecommendType {
  declare type: 'collaborativeFiltering';
  namespace?: string;
}

export class ExperimentMetadataCharacterRecommendationRecommendTypeGoogle extends ExperimentMetadataCharacterRecommendationRecommendType {
  declare type: 'google';
}

export class ExperimentMetadataCharacterVoicePrice extends ExperimentMetadata {
  declare type: 'characterVoicePrice';
  coinProductId?: string;
  priceByThreshold!: object;
  considerSpeed!: boolean;
}

export class ExperimentMetadataCoinProduct extends ExperimentMetadata {
  declare type: 'coinProduct';
  productType!: string;
  productIds!: string[];
}

export class ExperimentMetadataDefault extends ExperimentMetadata {
  declare type: 'default';
}

export class ExperimentMetadataExitBanner extends ExperimentMetadata {
  declare type: 'exitBanner';
  enabled!: boolean;
}

export class ExperimentMetadataInterstitial extends ExperimentMetadata {
  declare type: 'interstitial';
  threshold!: number;
  includeRegen!: boolean;
  showRegen!: boolean;
  useDefault!: boolean;
  timeBasedWeighting!: boolean;
  targetMinutePerImpression?: number;
  rateLimitInSeconds?: number;
  afterSignupMinutes!: number;
}

export class ExperimentMetadataMainLayout extends ExperimentMetadata {
  declare type: 'mainLayout';
  showDiscoverySection!: boolean;
  getDiscoveryV2Response!: boolean;
}

export class ExperimentMetadataModel extends ExperimentMetadata {
  declare type: 'model';
  speakerType?: ModelSpeakerType;
  host?: string;
  proHost?: string;
  contextLength?: number;
  @Type(() => IntRange)
  contextLengthRange?: IntRange;
  probability!: number;
  modelType!: ModelType;
  minimumLatencyMilliseconds?: number;
  shouldMultiSpeakerSupported?: boolean;
  @Type(() => Config)
  config?: Config;
  @Type(() => Config)
  regenConfig?: Config;
  @Type(() => MemoryConfig)
  memoryConfig?: MemoryConfig;
  isEnabled!: boolean;
}

export class ExperimentMetadataNewTopic extends ExperimentMetadata {
  declare type: 'newTopic';
}

export class ExperimentMetadataOpenStoreProduct extends ExperimentMetadata {
  declare type: 'openStoreProduct';
  productType!: string;
  storeType!: string;
  productIds!: string[];
}

export class ExperimentMetadataRanking extends ExperimentMetadata {
  declare type: 'ranking';
  showTopRankingSection!: boolean;
  rankingType!: string;
}

export class ExperimentMetadataRegenCap extends ExperimentMetadata {
  declare type: 'regenCap';
  threshold!: number;
  countType!: ExperimentMetadataRegenCapType;
}

export class ExperimentMetadataSimilarCharacterRecommendation extends ExperimentMetadata {
  declare type: 'similarCharacterRecommendation';
  @Type(() => ExperimentMetadataSimilarCharacterRecommendationRecommendType)
  recommendType!: ExperimentMetadataSimilarCharacterRecommendationRecommendType;
}

export class ExperimentMetadataSimilarCharacterRecommendationRecommendTypeCollaborativeFiltering extends ExperimentMetadataSimilarCharacterRecommendationRecommendType {
  declare type: 'collaborativeFiltering';
  namespace?: string;
}

export class ExperimentMetadataSimilarCharacterRecommendationRecommendTypeGoogle extends ExperimentMetadataSimilarCharacterRecommendationRecommendType {
  declare type: 'google';
}

export class ExperimentMetadataSlowChatNudge extends ExperimentMetadata {
  declare type: 'slowChatNudge';
  thresholdInMilliseconds?: number;
}

export class Limit extends ExperimentMetadata {
  declare type: 'limit';
  key!: string;
  limit?: number;
}

export class OnboardingCharacter extends ExperimentMetadata {
  declare type: 'onboardingCharacter';
  @Type(() => CharacterIdsByTargetGender)
  characterIdsByTargetGender?: CharacterIdsByTargetGender;
}

export class RecommendedMessageMetadata extends ExperimentMetadata {
  declare type: 'quickReply';
  numOfReplies!: number;
  duration!: number;
  modelUrl?: string;
}

export class UpdateABExperimentAdminRequest {
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt!: Date;
  metadataByBucket!: object;
  description?: string;
  minimumAppVersion?: string;
  @Type(() => Date)
  minimumUserCreatedAt?: Date;
  @Type(() => MABPrerequisite, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: SeedRangePrerequisite, name: 'SeedRange' },
        { value: GenderPrerequisite, name: 'Gender' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  prerequisites?: SeedRangePrerequisite[];
}

export class ABExperimentAdminApiDto {
  id!: string;
  seed!: string;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt!: Date;
  targetCountry!: Country;
  type!: ABExperimentType;
  metadataByBucket!: object;
  description?: string;
  minimumAppVersion?: string;
  @Type(() => Date)
  minimumUserCreatedAt?: Date;
  @Type(() => MABPrerequisite, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: SeedRangePrerequisite, name: 'SeedRange' },
        { value: GenderPrerequisite, name: 'Gender' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  prerequisites?: SeedRangePrerequisite[];
}

export class CreateWithdrawalRequest {
  type!: WithdrawalReportType;
  content!: string;
}

export class ExternalToken {
  issuer!: TokenIssuer;
  token!: string;
}

export class CreateUserRequest {
  deviceId!: string;
  username!: string;
  name!: string;
  chatProfileDescription?: string;
  birthdate!: string;
  @Type(() => ExternalToken)
  externalToken!: ExternalToken;
  gender!: Gender;
  country!: Country;
  marketingOptIn!: boolean;
  existingToken?: string;
}

export class TokenApiDto {
  accessToken!: string;
  refreshToken!: string;
}

export class CreateUserReportRequest {
  type!: ReportType;
  reason?: string;
}

export class UpdateFollowingCreatorNotificationEnabledRequest {
  isNotificationEnabled!: boolean;
}

export class CheckSignupRequest {
  @Type(() => ExternalToken)
  externalToken!: ExternalToken;
}

export class CheckSignupResponse {
  existingUserIssuer?: TokenIssuer;
}

export class BlockUserRequest {
  userId!: string;
}

export class CreateUserChatProfileRequest {
  name!: string;
  profileImageUrl?: string;
  description?: string;
}

export class UserChatProfileApiDto {
  id!: string;
  userId!: string;
  name!: string;
  profileImageUrl?: string;
  description?: string;
  selected!: boolean;
  isDefault!: boolean;
}

export class UpdateUserChatProfileImageRequest {
  image!: Blob;
  @Type(() => AreaCoordinates)
  cropCoordinates!: AreaCoordinates;
}

export class CreateUserChatProfileImageResponse {
  imageUrl!: string;
}

export class CheckAbusingUserChatProfileRequest {
  name!: string;
  description?: string;
}

export class CheckAbusingUserChatProfileResponse {
  isAbusing!: boolean;
}

export class TossPaymentsRequest {
  productId!: string;
}

export class TossPaymentsResponse {
  orderId!: string;
  orderName!: string;
}

export class TossPaymentsConfirmationRequest {
  paymentKey!: string;
  orderId!: string;
  amount!: number;
  purchaseChannel?: string;
}

export class CreateRoomRequest {
  plotId!: string;
  reason?: string;
}

export class LastMessageApiDto {
  id!: string;
  @Type(() => MessageApiDtoSender)
  sender!: MessageApiDtoSender;
  @Type(() => MessageApiDtoContentApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [{ value: MessageApiDtoTextApiDto, name: 'TEXT' }],
    },
    keepDiscriminatorProperty: true,
  })
  contents!: MessageApiDtoTextApiDto[];
  @Type(() => Date)
  messageTime!: Date;
}

export class PlotCreatorApiDto {
  id!: string;
  /**
   * @example dafunk
   */
  nickname!: string;
  /**
   * @example dafunk
   */
  username!: string;
  /**
   * @example https://avatars.githubusercontent.com/u/12345678?v=4
   */
  profileImageUrl?: string;
  isActive!: boolean;
}

export class PlotApiDto {
  id!: string;
  /**
   * @example 이루다
   */
  name?: string;
  initialRoomImageUrl?: string;
  /**
   * 캐릭터 설명
   */
  shortDescription?: string;
  longDescription?: string;
  @Type(() => PlotCharacterApiDto)
  characters!: PlotCharacterApiDto[];
  /**
   * 예시 대화
   */
  @Type(() => ExampleConversationApiDto)
  conversations?: ExampleConversationApiDto[];
  /**
   * @example 내 뱉을 첫 마디
   */
  greeting?: string;
  @Type(() => PlotIntroApiDto)
  intros?: PlotIntroApiDto[];
  isLongDescriptionPublic!: boolean;
  isExampleConversationPublic!: boolean;
  status!: PlotStatus;
  country!: Country;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  releasedAt?: Date;
  @Type(() => Date)
  updatedAt!: Date;
  interactionCount!: number;
  interactionCountWithRegen!: number;
  verified!: boolean;
  @Type(() => PlotCreatorApiDto)
  creator!: PlotCreatorApiDto;
  creatorComment?: string;
  hashtags!: string[];
  isPrivate!: boolean;
  isLocked!: boolean;
  isLiked!: boolean;
  originatedId?: string;
  supportedFeatures!: PlotFeature[];
}

export class RoomApiDto {
  id!: string;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => LastMessageApiDto)
  lastMessage?: LastMessageApiDto;
  isActive!: boolean;
  title?: string;
  unreadCount!: number;
  @Type(() => PlotApiDto)
  plot!: PlotApiDto;
}

export class CreateSavedRoomRequest {
  title?: string;
}

export class RecommendedMessageResponseMessage {
  id!: string;
  content!: string;
}

export class RecommendedMessageResponse {
  isAbusing!: boolean;
  @Type(() => RecommendedMessageResponseMessage)
  messages!: RecommendedMessageResponseMessage[];
}

export class CandidateApiDto {
  id!: string;
  @Type(() => MessageApiDtoTextApiDto)
  contents!: MessageApiDtoTextApiDto[];
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  messageTime!: Date;
  edited!: boolean;
  backgroundImageUrl?: string;
  facialImageUrl?: string;
  @Type(() => MessageVoiceApiDto)
  voice?: MessageVoiceApiDto;
  voicePrice?: number;
}

export class ChatStreamApiDtoCandidateCompleteApiDto extends ChatStreamApiDto {
  declare event: 'CANDIDATE_COMPLETE';
  @Type(() => CandidateApiDto)
  candidate!: CandidateApiDto;
  shouldNudgeSlowChat!: boolean;
}

export class ChatStreamApiDtoChangeFacialApiDto extends ChatStreamApiDto {
  declare event: 'CHANGE_FACIAL';
  imageUrl?: string;
}

export class ChatStreamApiDtoChatCompleteApiDto extends ChatStreamApiDto {
  declare event: 'CHAT_COMPLETE';
  @Type(() => MessageApiDto)
  replyMessage!: MessageApiDto;
  @Type(() => MessageApiDto)
  requestMessage?: MessageApiDto;
  shouldNudgeSlowChat!: boolean;
}

export class ChatStreamApiDtoChatDetectAbusingApiDto extends ChatStreamApiDto {
  declare event: 'DETECT_ABUSING';
  requestId!: string;
  type!: 'FORBIDDEN' | 'ABUSING';
}

export class ChatStreamApiDtoChatErrorApiDto extends ChatStreamApiDto {
  declare event: 'ERROR';
  type!: 'CHAT_ERROR';
}

export class ChatStreamApiDtoDetectSceneApiDto extends ChatStreamApiDto {
  declare event: 'DETECT_SCENE';
  messageId!: string;
}

export class ExampleMessageApiDtoTextApiDto {
  speakerName?: string;
  position?: SpeakerPosition;
  /**
   * @example 안녕하세요
   */
  text!: string;
}

export class ExampleMessageApiDto {
  senderType!: SenderType;
  @Type(() => ExampleMessageApiDtoTextApiDto)
  contents!: ExampleMessageApiDtoTextApiDto[];
  @Type(() => Date)
  messageTime!: Date;
}

export class ChatStreamApiDtoExampleChatCompleteApiDto extends ChatStreamApiDto {
  declare event: 'EXAMPLE_CHAT_COMPLETE';
  @Type(() => ExampleMessageApiDto)
  replyMessage!: ExampleMessageApiDto;
}

export class MessageChunkApiDtoTextApiDto {
  speakerName?: string;
  position?: SpeakerPosition;
  /**
   * @example 안녕하세요
   */
  text!: string;
}

export class MessageChunkApiDto {
  @Type(() => MessageApiDtoSender)
  sender!: MessageApiDtoSender;
  @Type(() => MessageChunkApiDtoTextApiDto)
  contents!: MessageChunkApiDtoTextApiDto[];
}

export class ChatStreamApiDtoChatInProgressApiDto extends ChatStreamApiDto {
  declare event: 'IN_PROGRESS';
  @Type(() => MessageChunkApiDto)
  chunkMessage!: MessageChunkApiDto;
}

export class SendMessageAndReceiveStreamRequestTextApiDto extends SendMessageAndReceiveStreamRequest {
  declare type: 'TEXT';
  /**
   * @example 안녕하세요
   */
  text!: string;
  recommendedMessageId?: string;
  isOnboardingMessage?: boolean;
}

export class CreatePlotReportRequest {
  type!: ReportType;
  reason?: string;
}

export class PlotExampleChatRequest {
  @Type(() => ExampleMessageApiDto)
  messages!: ExampleMessageApiDto[];
}

export class EstimateVoicePriceRequest {
  text!: string;
}

export class GetCreateCharacterVoicePriceResponse {
  price?: number;
}

export class RateGeneratedCharacterImageRequest {
  imageUrl!: string;
  react!: RateGeneratedCharacterImageRequestReact;
}

export class CropImageRequest {
  image!: Blob;
  @Type(() => AreaCoordinates)
  cropCoordinates!: AreaCoordinates;
}

export class CropImageResponse {
  imageUrl!: string;
}

export class ReportBackgroundImageRequest {
  url!: string;
  types!: ReportBackgroundImageRequestType[];
  reason?: string;
}

export class GenerateBackgroundImageResponseImage {
  url!: string;
  isCensored!: boolean;
}

export class GenerateBackgroundImageResponse {
  @Type(() => GenerateBackgroundImageResponseImage)
  images!: GenerateBackgroundImageResponseImage[];
}

export class PlotProfileImageGenerateJobRequest {
  prompt!: string;
  seed?: number;
  styleId!: string;
  quantity!: number;
}

export class RegisterPlotProfileImageGenerationJobResponse {
  jobIds!: string[];
}

export class PlotProfileImagePromptTranslationRequest {
  prompt!: string;
  sourceLanguage!: 'KO' | 'JA' | 'EN';
  plotId!: string;
}

export class GetPlotProfileImagePromptTranslationResponse {
  translatedPrompt!: string;
}

export class GenerateProfileImageTagsRequestV2 {
  image!: Blob;
  @Type(() => AreaCoordinates)
  cropCoordinates?: AreaCoordinates[];
  plotId!: string;
}

export class GenerateProfileImageTagsResponse {
  keywords!: string[];
}

export class ReportCharacterProfileImageGenerationResultRequest {
  types!: ReportCharacterProfileImageGenerationResultRequestType[];
  reason?: string;
}

export class BlockHashtagRequest {
  hashtag!: string;
}

export class MarkPlotDiscoveryRequest {
  plotIds!: string[];
}

export class BlockPlotRequest {
  plotId!: string;
}

export class PurchaseRequest {
  /**
   * 스토어 결제 트랜잭션 ID
   */
  token!: string;
  purchaseChannel?: string;
}

export class AppStoreNotificationRequest {
  signedPayload!: string;
}

export class ApiUserDto {
  id!: string;
  name!: string;
  apiKey!: string;
  rps!: number;
  @Type(() => Date)
  createdAt!: Date;
  isActive!: boolean;
}

export class ApiUserAuthContext {
  @Type(() => ApiUserDto)
  apiUser!: ApiUserDto;
}

export class OpenApiChatRequestCharacterExampleConversationMessage {
  sender!: SenderType;
  content!: string;
}

export class OpenApiChatRequestCharacterExampleConversation {
  @Type(() => OpenApiChatRequestCharacterExampleConversationMessage)
  messages!: OpenApiChatRequestCharacterExampleConversationMessage[];
}

export class OpenApiChatRequestCharacter {
  name!: string;
  shortDescription?: string;
  longDescription?: string;
  @Type(() => OpenApiChatRequestCharacterExampleConversation)
  exampleConversations!: OpenApiChatRequestCharacterExampleConversation[];
}

export class OpenApiChatRequestGenerationConfig {
  maxOutputTokens?: number;
}

export class OpenApiChatRequestConfig {
  userAbusing!: object;
  characterAbusing!: object;
  @Type(() => OpenApiChatRequestGenerationConfig)
  generationConfig?: OpenApiChatRequestGenerationConfig;
  country!: Country;
  skipAbusing!: boolean;
  skipModelAbusing!: boolean;
}

export class OpenApiChatRequestMessage {
  sender!: SenderType;
  content!: string;
  @Type(() => Date)
  time!: Date;
}

export class OpenApiChatRequestUser {
  name!: string;
}

export class OpenApiChatRequest {
  roomId!: string;
  @Type(() => OpenApiChatRequestUser)
  user!: OpenApiChatRequestUser;
  @Type(() => OpenApiChatRequestCharacter)
  character!: OpenApiChatRequestCharacter;
  @Type(() => OpenApiChatRequestMessage)
  conversations!: OpenApiChatRequestMessage[];
  @Type(() => OpenApiChatRequestConfig)
  config!: OpenApiChatRequestConfig;
}

export class OpenApiChatJsonResponseAbusing {
  sender!: SenderType;
  type!:
    | 'SEXUAL'
    | 'BIAS'
    | 'VIOLENCE'
    | 'POLITICS'
    | 'TOBACCO'
    | 'ALCOHOL'
    | 'DRUGS'
    | 'GAMBLE'
    | 'CRIME'
    | 'KOREAN_TEST';
}

export class OpenApiChatJsonResponseChat {
  text!: string;
}

export class OpenApiChatMetadata {
  inputTokenLength!: number;
  outputTokenLength!: number;
}

export class OpenApiChatJsonResponse {
  @Type(() => OpenApiChatJsonResponseChat)
  chat?: OpenApiChatJsonResponseChat;
  @Type(() => OpenApiChatJsonResponseAbusing)
  abusing?: OpenApiChatJsonResponseAbusing;
  @Type(() => OpenApiChatMetadata)
  metadata?: OpenApiChatMetadata;
}

export class AbusingDetected extends OpenApiChatResponse {
  declare type: 'ABUSING_DETECTED';
  sender!: SenderType;
  abusingType!:
    | 'SEXUAL'
    | 'BIAS'
    | 'VIOLENCE'
    | 'POLITICS'
    | 'TOBACCO'
    | 'ALCOHOL'
    | 'DRUGS'
    | 'GAMBLE'
    | 'CRIME'
    | 'KOREAN_TEST';
}

export class Complete extends OpenApiChatResponse {
  declare type: 'COMPLETE';
  text!: string;
  @Type(() => OpenApiChatMetadata)
  metadata?: OpenApiChatMetadata;
}

export class Error extends OpenApiChatResponse {
  declare type: 'ERROR';
  reason!: string;
}

export class InProgress extends OpenApiChatResponse {
  declare type: 'IN_PROGRESS';
  text!: string;
}

export class PincruxOfferwallRewardRequest {
  app_key!: string;
  pub_key!: number;
  user_key!: string;
  coin!: number;
  transaction_id!: string;
  app_title!: string;
  resign_flag!: 'Y' | 'N';
}

export class BuzzvilOfferwallRewardRequest {
  userId!: string;
  transactionId!: string;
  point!: number;
  unitId!: number;
  title!: string;
  actionType!: string;
  eventAt!: number;
  extra!: string;
}

export class AdPopcornOfferwallRewardRequest {
  userId!: string;
  rewardKey!: string;
  campaignKey!: string;
  quantity!: number;
  signedValue!: string;
  campaignName!: string;
  campaignType!: number;
  appKey!: number;
  appName!: string;
  timestamp!: number;
  adid?: string;
  idfa?: string;
  mediaPrice!: number;
}

export class AdPopcornOfferwallRewardResponse {
  Result!: boolean;
  ResultCode!: number;
  ResultMsg!: string;
}

export class VerifyRefreshTokenRequest {
  refreshToken!: string;
}

export class SendSmsRequest {
  countryCode!: string;
  number!: string;
  hashForAutoComplete?: string;
}

export class VerifySmsRequest {
  countryCode!: string;
  number!: string;
  code!: string;
}

export class NuttyRefundRequest {
  name!: string;
  bankName!: string;
  bankAccountNumber!: string;
}

export class CreateContactRequest {
  mainCategoryId!: string;
  subCategoryId!: string;
  title!: string;
  content!: string;
}

export class SupportCategoryApiDto {
  id!: string;
  name!: string;
  description?: string;
}

export class ContactApiDto {
  id!: string;
  @Type(() => SupportCategoryApiDto)
  mainCategory!: SupportCategoryApiDto;
  @Type(() => SupportCategoryApiDto)
  subCategory!: SupportCategoryApiDto;
  title!: string;
  content!: string;
  status!: ContactStatus;
  @Type(() => Date)
  createdAt!: Date;
}

export class CreateContactReplyRequest {
  content!: string;
}

export class ContactReplyApiDto {
  id!: string;
  content!: string;
  isWrittenByAdmin!: boolean;
  @Type(() => Date)
  createdAt!: Date;
}

export class CreateContactAttachmentRequest {
  files!: Blob[];
}

export class ContactAttachmentApiDto {
  id!: string;
  isUploadedByAdmin!: boolean;
  fileUrl!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListContactAttachmentResponse {
  @Type(() => ContactAttachmentApiDto)
  contactAttachments!: ContactAttachmentApiDto[];
}

export class CoinDailyRewardResponse {
  success!: boolean;
}

export class PurchaseCoinProductRequest {
  purchaseChannel!: string;
}

export class IssueTokenRequestAnonymous extends IssueTokenRequest {
  declare type: 'anonymous';
  country!: Country;
}

export class IssueTokenRequestExternal extends IssueTokenRequest {
  declare type: 'external';
  @Type(() => ExternalToken)
  externalToken!: ExternalToken;
}

export class IssueTokenRequestRefresh extends IssueTokenRequest {
  declare type: 'refresh';
  refreshToken!: string;
}

export class IssueTokenRequestSecretCode extends IssueTokenRequest {
  declare type: 'secretCode';
  secretCode!: string;
}

export class DebugSendAppPushRequest {
  body!: string;
}

export class ExportZetaReportRequest {
  @Type(() => Date)
  start!: Date;
  @Type(() => Date)
  end!: Date;
}

export class ExportZetaReportResponse {
  url!: string;
}

export class LocalTime {
  hour?: number;
  minute?: number;
  second?: number;
  nano?: number;
}

export class UpdateUserAdminApiDto {
  name!: string;
  nickname!: string;
  username!: string;
  email?: string;
  profileImageUrl?: string;
  description?: string;
  gender!: Gender;
  timeZone!: object;
  country!: Country;
  birthdate?: string;
  isDangerous!: boolean;
  isBackgroundEnabled!: boolean;
  marketingOptIn!: boolean;
  sexualContentsAllowed!: boolean;
}

export class UserBlockAdminApiDto {
  id!: number;
  type!: BlockType;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt?: Date;
  reasonType?: BlockReasonType;
  reason?: string;
  adminId?: string;
}

export class UserAdminApiDto {
  id!: string;
  name!: string;
  nickname!: string;
  username!: string;
  email?: string;
  profileImageUrl?: string;
  description?: string;
  gender!: Gender;
  timeZone!: object;
  country!: Country;
  isAnonymous!: boolean;
  birthdate?: string;
  status!: 'ACTIVE' | 'WITHDRAWAL' | 'BANNED';
  isDangerous!: boolean;
  marketingOptIn!: boolean;
  sexualContentsAllowed!: boolean;
  isBackgroundEnabled!: boolean;
  isStaff!: boolean;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => UserBlockAdminApiDto)
  blockedHistories?: UserBlockAdminApiDto[];
}

export class UserPenaltyRequest {
  type!: UserProfilePenaltyType;
  level!: PenaltyLevel;
  message!: string;
  profileFieldsToDelete!: UserProfileField[];
  blockDays?: number;
}

export class UserBlockRequestPermanent extends UserBlockRequest {
  declare type: 'PERMANENT';
}

export class UserBlockRequestTemporary extends UserBlockRequest {
  declare type: 'TEMPORARY';
  day!: number;
}

export class AdminSearchBooleanConditionIs extends AdminSearchBooleanCondition {
  declare type: 'booleanIs';
  value!: boolean;
}

export class AdminSearchBooleanConditionIsNotNull extends AdminSearchBooleanCondition {
  declare type: 'booleanIsNotNull';
}

export class AdminSearchBooleanConditionIsNull extends AdminSearchBooleanCondition {
  declare type: 'booleanIsNull';
}

export class AdminSearchConditionPagination {
  page!: number;
  size!: number;
}

export class AdminSearchConditionSortAsc extends AdminSearchConditionSort {
  declare type: 'asc';
}

export class AdminSearchConditionSortDesc extends AdminSearchConditionSort {
  declare type: 'desc';
}

export class UserAdminSearchConditionSort {
  field!:
    | 'id'
    | 'name'
    | 'email'
    | 'gender'
    | 'country'
    | 'isAnonymous'
    | 'status'
    | 'isDangerous'
    | 'marketingOptIn'
    | 'sexualContentsAllowed'
    | 'isBackgroundEnabled'
    | 'createdAt';
  @Type(() => AdminSearchConditionSort, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchConditionSortAsc, name: 'asc' },
        { value: AdminSearchConditionSortDesc, name: 'desc' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  order!: AdminSearchConditionSortAsc | AdminSearchConditionSortDesc;
}

export class UserProfileAdminSearchConditionSort {
  field!:
    | 'userId'
    | 'username'
    | 'nickname'
    | 'profileImageUrl'
    | 'birthdate'
    | 'description';
  @Type(() => AdminSearchConditionSort, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchConditionSortAsc, name: 'asc' },
        { value: AdminSearchConditionSortDesc, name: 'desc' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  order!: AdminSearchConditionSortAsc | AdminSearchConditionSortDesc;
}

export class PlotMonitoringHistoryAdminSearchConditionSort {
  field!: 'id' | 'plotId' | 'adminId' | 'action' | 'stage' | 'createdAt';
  @Type(() => AdminSearchConditionSort, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchConditionSortAsc, name: 'asc' },
        { value: AdminSearchConditionSortDesc, name: 'desc' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  order!: AdminSearchConditionSortAsc | AdminSearchConditionSortDesc;
}

export class AdminSearchDateConditionAt extends AdminSearchDateCondition {
  declare type: 'dateAt';
  @Type(() => Date)
  value!: Date;
}

export class AdminSearchDateConditionIsNotNull extends AdminSearchDateCondition {
  declare type: 'dateIsNotNull';
}

export class AdminSearchDateConditionIsNull extends AdminSearchDateCondition {
  declare type: 'dateIsNull';
}

export class AdminSearchDateConditionRange extends AdminSearchDateCondition {
  declare type: 'dateRange';
  @Type(() => Date)
  start?: Date;
  @Type(() => Date)
  end?: Date;
}

export class AdminSearchStringConditionEnds extends AdminSearchStringCondition {
  declare type: 'stringEnds';
  value!: string;
  ignoreCase!: boolean;
}

export class AdminSearchStringConditionExact extends AdminSearchStringCondition {
  declare type: 'stringExact';
  value!: string;
  ignoreCase!: boolean;
}

export class AdminSearchStringConditionIn extends AdminSearchStringCondition {
  declare type: 'stringIn';
  values!: string[];
}

export class AdminSearchStringConditionInclude extends AdminSearchStringCondition {
  declare type: 'stringInclude';
  value!: string;
  ignoreCase!: boolean;
}

export class AdminSearchStringConditionIsNotNull extends AdminSearchStringCondition {
  declare type: 'stringIsNotNull';
}

export class AdminSearchStringConditionIsNull extends AdminSearchStringCondition {
  declare type: 'stringIsNull';
}

export class AdminSearchStringConditionNotIn extends AdminSearchStringCondition {
  declare type: 'stringNotIn';
  values!: string[];
}

export class AdminSearchStringConditionStarts extends AdminSearchStringCondition {
  declare type: 'stringStarts';
  value!: string;
  ignoreCase!: boolean;
}

export class UserAdminSearchConditionSortCountry extends UserAdminSearchConditionSort {
  declare field: 'country';
}

export class UserAdminSearchConditionSortCreatedAt extends UserAdminSearchConditionSort {
  declare field: 'createdAt';
}

export class UserAdminSearchConditionSortEmail extends UserAdminSearchConditionSort {
  declare field: 'email';
}

export class UserAdminSearchConditionSortGender extends UserAdminSearchConditionSort {
  declare field: 'gender';
}

export class UserAdminSearchConditionSortId extends UserAdminSearchConditionSort {
  declare field: 'id';
}

export class UserAdminSearchConditionSortIsAnonymous extends UserAdminSearchConditionSort {
  declare field: 'isAnonymous';
}

export class UserAdminSearchConditionSortIsBackgroundEnabled extends UserAdminSearchConditionSort {
  declare field: 'isBackgroundEnabled';
}

export class UserAdminSearchConditionSortIsDangerous extends UserAdminSearchConditionSort {
  declare field: 'isDangerous';
}

export class UserAdminSearchConditionSortMarketingOptIn extends UserAdminSearchConditionSort {
  declare field: 'marketingOptIn';
}

export class UserAdminSearchConditionSortName extends UserAdminSearchConditionSort {
  declare field: 'name';
}

export class UserAdminSearchConditionSortSexualContentsAllowed extends UserAdminSearchConditionSort {
  declare field: 'sexualContentsAllowed';
}

export class UserAdminSearchConditionSortStatus extends UserAdminSearchConditionSort {
  declare field: 'status';
}

export class UserAdminSearchCondition {
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  id?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  name?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  email?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  gender?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  country?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchBooleanCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchBooleanConditionIs, name: 'booleanIs' },
        { value: AdminSearchBooleanConditionIsNull, name: 'booleanIsNull' },
        {
          value: AdminSearchBooleanConditionIsNotNull,
          name: 'booleanIsNotNull',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  isAnonymous?:
    | AdminSearchBooleanConditionIs
    | AdminSearchBooleanConditionIsNotNull
    | AdminSearchBooleanConditionIsNull;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  status?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchBooleanCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchBooleanConditionIs, name: 'booleanIs' },
        { value: AdminSearchBooleanConditionIsNull, name: 'booleanIsNull' },
        {
          value: AdminSearchBooleanConditionIsNotNull,
          name: 'booleanIsNotNull',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  isDangerous?:
    | AdminSearchBooleanConditionIs
    | AdminSearchBooleanConditionIsNotNull
    | AdminSearchBooleanConditionIsNull;
  @Type(() => AdminSearchBooleanCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchBooleanConditionIs, name: 'booleanIs' },
        { value: AdminSearchBooleanConditionIsNull, name: 'booleanIsNull' },
        {
          value: AdminSearchBooleanConditionIsNotNull,
          name: 'booleanIsNotNull',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  marketingOptIn?:
    | AdminSearchBooleanConditionIs
    | AdminSearchBooleanConditionIsNotNull
    | AdminSearchBooleanConditionIsNull;
  @Type(() => AdminSearchBooleanCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchBooleanConditionIs, name: 'booleanIs' },
        { value: AdminSearchBooleanConditionIsNull, name: 'booleanIsNull' },
        {
          value: AdminSearchBooleanConditionIsNotNull,
          name: 'booleanIsNotNull',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  sexualContentsAllowed?:
    | AdminSearchBooleanConditionIs
    | AdminSearchBooleanConditionIsNotNull
    | AdminSearchBooleanConditionIsNull;
  @Type(() => AdminSearchBooleanCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchBooleanConditionIs, name: 'booleanIs' },
        { value: AdminSearchBooleanConditionIsNull, name: 'booleanIsNull' },
        {
          value: AdminSearchBooleanConditionIsNotNull,
          name: 'booleanIsNotNull',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  isBackgroundEnabled?:
    | AdminSearchBooleanConditionIs
    | AdminSearchBooleanConditionIsNotNull
    | AdminSearchBooleanConditionIsNull;
  @Type(() => AdminSearchDateCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchDateConditionAt, name: 'dateAt' },
        { value: AdminSearchDateConditionRange, name: 'dateRange' },
        { value: AdminSearchDateConditionIsNull, name: 'dateIsNull' },
        { value: AdminSearchDateConditionIsNotNull, name: 'dateIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  createdAt?:
    | AdminSearchDateConditionAt
    | AdminSearchDateConditionIsNotNull
    | AdminSearchDateConditionIsNull
    | AdminSearchDateConditionRange;
  @Type(() => AdminSearchConditionPagination)
  pagination!: AdminSearchConditionPagination;
  @Type(() => UserAdminSearchConditionSort, {
    discriminator: {
      property: 'field',
      subTypes: [
        { value: UserAdminSearchConditionSortId, name: 'id' },
        { value: UserAdminSearchConditionSortName, name: 'name' },
        { value: UserAdminSearchConditionSortEmail, name: 'email' },
        { value: UserAdminSearchConditionSortGender, name: 'gender' },
        { value: UserAdminSearchConditionSortCountry, name: 'country' },
        { value: UserAdminSearchConditionSortIsAnonymous, name: 'isAnonymous' },
        { value: UserAdminSearchConditionSortStatus, name: 'status' },
        { value: UserAdminSearchConditionSortIsDangerous, name: 'isDangerous' },
        {
          value: UserAdminSearchConditionSortMarketingOptIn,
          name: 'marketingOptIn',
        },
        {
          value: UserAdminSearchConditionSortSexualContentsAllowed,
          name: 'sexualContentsAllowed',
        },
        {
          value: UserAdminSearchConditionSortIsBackgroundEnabled,
          name: 'isBackgroundEnabled',
        },
        { value: UserAdminSearchConditionSortCreatedAt, name: 'createdAt' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  sort?: (
    | UserAdminSearchConditionSortCountry
    | UserAdminSearchConditionSortCreatedAt
    | UserAdminSearchConditionSortEmail
    | UserAdminSearchConditionSortGender
    | UserAdminSearchConditionSortId
    | UserAdminSearchConditionSortIsAnonymous
    | UserAdminSearchConditionSortIsBackgroundEnabled
    | UserAdminSearchConditionSortIsDangerous
    | UserAdminSearchConditionSortMarketingOptIn
    | UserAdminSearchConditionSortName
    | UserAdminSearchConditionSortSexualContentsAllowed
    | UserAdminSearchConditionSortStatus
  )[];
}

export class ListUserAdminResponse {
  @Type(() => UserAdminApiDto)
  users!: UserAdminApiDto[];
  nextPage?: number;
}

export class UserProfileAdminSearchConditionSortBirthdate extends UserProfileAdminSearchConditionSort {
  declare field: 'birthdate';
}

export class UserProfileAdminSearchConditionSortDescription extends UserProfileAdminSearchConditionSort {
  declare field: 'description';
}

export class UserProfileAdminSearchConditionSortNickname extends UserProfileAdminSearchConditionSort {
  declare field: 'nickname';
}

export class UserProfileAdminSearchConditionSortProfileImageUrl extends UserProfileAdminSearchConditionSort {
  declare field: 'profileImageUrl';
}

export class UserProfileAdminSearchConditionSortUserId extends UserProfileAdminSearchConditionSort {
  declare field: 'userId';
}

export class UserProfileAdminSearchConditionSortUsername extends UserProfileAdminSearchConditionSort {
  declare field: 'username';
}

export class UserProfileAdminSearchCondition {
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  userId?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  username?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  nickname?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  profileImageUrl?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchDateCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchDateConditionAt, name: 'dateAt' },
        { value: AdminSearchDateConditionRange, name: 'dateRange' },
        { value: AdminSearchDateConditionIsNull, name: 'dateIsNull' },
        { value: AdminSearchDateConditionIsNotNull, name: 'dateIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  birthdate?:
    | AdminSearchDateConditionAt
    | AdminSearchDateConditionIsNotNull
    | AdminSearchDateConditionIsNull
    | AdminSearchDateConditionRange;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  description?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchConditionPagination)
  pagination!: AdminSearchConditionPagination;
  @Type(() => UserProfileAdminSearchConditionSort, {
    discriminator: {
      property: 'field',
      subTypes: [
        { value: UserProfileAdminSearchConditionSortUserId, name: 'userId' },
        {
          value: UserProfileAdminSearchConditionSortUsername,
          name: 'username',
        },
        {
          value: UserProfileAdminSearchConditionSortNickname,
          name: 'nickname',
        },
        {
          value: UserProfileAdminSearchConditionSortProfileImageUrl,
          name: 'profileImageUrl',
        },
        {
          value: UserProfileAdminSearchConditionSortBirthdate,
          name: 'birthdate',
        },
        {
          value: UserProfileAdminSearchConditionSortDescription,
          name: 'description',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  sort?: (
    | UserProfileAdminSearchConditionSortBirthdate
    | UserProfileAdminSearchConditionSortDescription
    | UserProfileAdminSearchConditionSortNickname
    | UserProfileAdminSearchConditionSortProfileImageUrl
    | UserProfileAdminSearchConditionSortUserId
    | UserProfileAdminSearchConditionSortUsername
  )[];
}

export class CreateOrExtendUserTierAdminRequest {
  type!: 'NORMAL' | 'PRO';
  userIds!: string[];
  isTrial!: boolean;
  extendTimeMillis!: number;
  reason!: string;
}

export class UserTierAdminApiDto {
  type!: 'NORMAL' | 'PRO';
  userId!: string;
  isTrial!: boolean;
  @Type(() => Date)
  expiredAt?: Date;
}

export class ListUserTierAdminResponse {
  @Type(() => UserTierAdminApiDto)
  userTiers!: UserTierAdminApiDto[];
}

export class CreateUserCharacterSkinRequest {
  skinId!: string;
  userId!: string;
}

export class TossPaymentsCancellationRequest {
  paymentKey!: string;
  cancelReason!: string;
  cancelAmount?: number;
  currency!: string;
}

export class AdminTokenRequest {
  token!: string;
}

export class AdminTokenResponse {
  token!: string;
}

export class CreateSupportCategoryAdminRequest {
  parentCategoryId?: string;
  name!: string;
  description?: string;
  sequence!: number;
  type!: SupportCategoryType;
}

export class StoryCurationAdminApiDto {
  storyId!: string;
  sequence!: number;
}

export class RegisterStoryCurationByAdminRequest {
  @Type(() => StoryCurationAdminApiDto)
  items!: StoryCurationAdminApiDto[];
}

export class RegisterStaffRequest {
  name!: string;
  email!: string;
}

export class StaffAdminApiDto {
  name!: string;
  email?: string;
  @Type(() => Date)
  registeredAt!: Date;
}

export class PopupAdminApiDto {
  id!: string;
  country!: Country;
  imageUrl!: string;
  isActive!: boolean;
  isProOnly!: boolean;
  @Type(() => ClickAction, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: ProPurchaseModal, name: 'proPurchaseModal' },
        { value: ExternalLink, name: 'externalLink' },
        { value: Navigate, name: 'navigate' },
        { value: EventModal, name: 'eventModal' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  clickAction!: EventModal | ExternalLink | Navigate | ProPurchaseModal;
  @Type(() => Date)
  createdAt!: Date;
  minimumAppVersion?: string;
  @Type(() => TargetABExperimentApiDto)
  targetABExperiment?: TargetABExperimentApiDto;
}

export class UploadPopupImageRequest {
  files!: Blob[];
}

export class UploadPopupImageResponse {
  urls!: string[];
}

export class CreatePolicyRequest {
  content!: string;
  applyDate!: string;
}

export class PolicySummaryApiDto {
  id!: string;
  applyDate!: string;
}

export class SendZetaBotPushRequest {
  userIds!: string[];
  message!: string;
  pushMessage!: string;
}

export class SendProfileImageDeletedPlotRequest {
  plotIds!: string[];
}

export class AdminSearchNumberConditionEqual extends AdminSearchNumberCondition {
  declare type: 'numberEqual';
  value!: number;
}

export class AdminSearchNumberConditionIsNotNull extends AdminSearchNumberCondition {
  declare type: 'numberIsNotNull';
}

export class AdminSearchNumberConditionIsNull extends AdminSearchNumberCondition {
  declare type: 'numberIsNull';
}

export class AdminSearchNumberConditionRange extends AdminSearchNumberCondition {
  declare type: 'numberRange';
  start?: number;
  end?: number;
}

export class PlotMonitoringHistoryAdminSearchConditionSortAction extends PlotMonitoringHistoryAdminSearchConditionSort {
  declare field: 'action';
}

export class PlotMonitoringHistoryAdminSearchConditionSortAdminId extends PlotMonitoringHistoryAdminSearchConditionSort {
  declare field: 'adminId';
}

export class PlotMonitoringHistoryAdminSearchConditionSortCreatedAt extends PlotMonitoringHistoryAdminSearchConditionSort {
  declare field: 'createdAt';
}

export class PlotMonitoringHistoryAdminSearchConditionSortId extends PlotMonitoringHistoryAdminSearchConditionSort {
  declare field: 'id';
}

export class PlotMonitoringHistoryAdminSearchConditionSortPlotId extends PlotMonitoringHistoryAdminSearchConditionSort {
  declare field: 'plotId';
}

export class PlotMonitoringHistoryAdminSearchConditionSortStage extends PlotMonitoringHistoryAdminSearchConditionSort {
  declare field: 'stage';
}

export class PlotMonitoringHistoryAdminSearchCondition {
  @Type(() => AdminSearchNumberCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchNumberConditionEqual, name: 'numberEqual' },
        { value: AdminSearchNumberConditionRange, name: 'numberRange' },
        { value: AdminSearchNumberConditionIsNull, name: 'numberIsNull' },
        { value: AdminSearchNumberConditionIsNotNull, name: 'numberIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  id?:
    | AdminSearchNumberConditionEqual
    | AdminSearchNumberConditionIsNotNull
    | AdminSearchNumberConditionIsNull
    | AdminSearchNumberConditionRange;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  plotId?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  adminId?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  action?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchStringCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchStringConditionExact, name: 'stringExact' },
        { value: AdminSearchStringConditionInclude, name: 'stringInclude' },
        { value: AdminSearchStringConditionStarts, name: 'stringStarts' },
        { value: AdminSearchStringConditionEnds, name: 'stringEnds' },
        { value: AdminSearchStringConditionIn, name: 'stringIn' },
        { value: AdminSearchStringConditionNotIn, name: 'stringNotIn' },
        { value: AdminSearchStringConditionIsNull, name: 'stringIsNull' },
        { value: AdminSearchStringConditionIsNotNull, name: 'stringIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  stage?:
    | AdminSearchStringConditionEnds
    | AdminSearchStringConditionExact
    | AdminSearchStringConditionIn
    | AdminSearchStringConditionInclude
    | AdminSearchStringConditionIsNotNull
    | AdminSearchStringConditionIsNull
    | AdminSearchStringConditionNotIn
    | AdminSearchStringConditionStarts;
  @Type(() => AdminSearchDateCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: AdminSearchDateConditionAt, name: 'dateAt' },
        { value: AdminSearchDateConditionRange, name: 'dateRange' },
        { value: AdminSearchDateConditionIsNull, name: 'dateIsNull' },
        { value: AdminSearchDateConditionIsNotNull, name: 'dateIsNotNull' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  createdAt?:
    | AdminSearchDateConditionAt
    | AdminSearchDateConditionIsNotNull
    | AdminSearchDateConditionIsNull
    | AdminSearchDateConditionRange;
  @Type(() => AdminSearchConditionPagination)
  pagination!: AdminSearchConditionPagination;
  @Type(() => PlotMonitoringHistoryAdminSearchConditionSort, {
    discriminator: {
      property: 'field',
      subTypes: [
        { value: PlotMonitoringHistoryAdminSearchConditionSortId, name: 'id' },
        {
          value: PlotMonitoringHistoryAdminSearchConditionSortPlotId,
          name: 'plotId',
        },
        {
          value: PlotMonitoringHistoryAdminSearchConditionSortAdminId,
          name: 'adminId',
        },
        {
          value: PlotMonitoringHistoryAdminSearchConditionSortAction,
          name: 'action',
        },
        {
          value: PlotMonitoringHistoryAdminSearchConditionSortStage,
          name: 'stage',
        },
        {
          value: PlotMonitoringHistoryAdminSearchConditionSortCreatedAt,
          name: 'createdAt',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  sort?: (
    | PlotMonitoringHistoryAdminSearchConditionSortAction
    | PlotMonitoringHistoryAdminSearchConditionSortAdminId
    | PlotMonitoringHistoryAdminSearchConditionSortCreatedAt
    | PlotMonitoringHistoryAdminSearchConditionSortId
    | PlotMonitoringHistoryAdminSearchConditionSortPlotId
    | PlotMonitoringHistoryAdminSearchConditionSortStage
  )[];
}

export class PlotMonitoringHistoryApiDto {
  id!: number;
  plotId!: string;
  adminId!: string;
  action!: PlotStatus;
  stage?: 'PROFILE_IMAGE' | 'PROMPT';
  @Type(() => Date)
  createdAt!: Date;
}

export class ListPlotMonitoringHistoryResponse {
  @Type(() => PlotMonitoringHistoryApiDto)
  histories!: PlotMonitoringHistoryApiDto[];
  nextPage?: number;
}

export class CreatePlotPoolAdminRequest {
  name!: string;
  description!: string;
}

export class CreatePlotPoolRelationAdminRequest {
  plotId!: string;
  priority!: number;
}

export class PlotPoolRelationAdminApiDto {
  id!: string;
  plotPoolId!: string;
  plotId!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class CreatePlotLifecyclePoolRelationAdminRequest {
  plotId!: string;
}

export class PlotLifecyclePoolRelationAdminApiDto {
  id!: string;
  plotLifecyclePoolId!: string;
  plotId!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class CheckPlotImageMonitoringRequest {
  plotId!: string;
  imageUrl!: string;
  action!: PlotImageMonitoringAction;
}

export class CreateOpenStoreProductRequest {
  id!: string;
  country!: Country;
  productType!: ProductType;
  status!: ProductStatus;
  name!: string;
  amount!: number;
  bonusAmount!: number;
  price!: number;
  discountedPrice!: number;
  currency!: string;
  @Type(() => Date)
  availableUntil?: Date;
  description?: string;
}

export class CreateOpenStoreProductPurchaseRequest {
  token!: string;
  userId!: string;
}

export class CreateApiUserRequest {
  name!: string;
  rps!: number;
  isActive!: boolean;
}

export class CreateLayoutRequest {
  name!: string;
  sectionIds!: string[];
  priority!: number;
  @Type(() => LayoutApiDtoFilter)
  filters!: LayoutApiDtoFilter[];
}

export class CreateLayoutSectionRequest {
  name!: string;
  @Type(() => LayoutSectionDisplayApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: BigProfile, name: 'BigProfile' },
        { value: SmallProfile, name: 'SmallProfile' },
        { value: RecommendedReply, name: 'RecommendedReply' },
        { value: Ranking, name: 'Ranking' },
        {
          value: RecentlyCreatedWithMoreView,
          name: 'RecentlyCreatedWithMoreView',
        },
        { value: LayoutSectionDisplayApiDtoTiktokEvent, name: 'TiktokEvent' },
        {
          value: LayoutSectionDisplayApiDtoPlotPoolMoreView,
          name: 'PlotPoolMoreView',
        },
        {
          value: LayoutSectionDisplayApiDtoDiscoveryRecommendedRefreshView,
          name: 'DiscoveryRecommendedRefreshView',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  display!:
    | BigProfile
    | LayoutSectionDisplayApiDtoDiscoveryRecommendedRefreshView
    | LayoutSectionDisplayApiDtoPlotPoolMoreView
    | LayoutSectionDisplayApiDtoTiktokEvent
    | Ranking
    | RecentlyCreatedWithMoreView
    | RecommendedReply
    | SmallProfile;
  @Type(() => LayoutSectionContentApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: PlotId, name: 'PlotId' },
        { value: PlotIdAndReply, name: 'PlotIdAndReply' },
        { value: RecentlyPopular, name: 'RecentlyPopular' },
        { value: RecentlyCreated, name: 'RecentlyCreated' },
        { value: CollaborativeFiltering, name: 'CollaborativeFiltering' },
        { value: RelatedPlot, name: 'RelatedPlot' },
        { value: DiscoveryRecommended, name: 'DiscoveryRecommended' },
        { value: PlotPool, name: 'PlotPool' },
        {
          value: PlotLifecyclePoolHighQuality,
          name: 'PlotLifecyclePoolHighQuality',
        },
        { value: PlotLifecycleRandom, name: 'PlotLifecycleRandom' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  content!:
    | CollaborativeFiltering
    | DiscoveryRecommended
    | PlotId
    | PlotIdAndReply
    | PlotLifecyclePoolHighQuality
    | PlotLifecycleRandom
    | PlotPool
    | RecentlyCreated
    | RecentlyPopular
    | RelatedPlot;
}

export class SendLayoutNominatorNotificationRequest {
  layoutId!: string;
  messageTemplate!: string;
  pushMessageTemplate!: string;
}

export class LayoutNominatorNotificationResultApiDto {
  creatorId!: string;
  plotId!: string;
  layoutSectionId!: string;
  message!: string;
  pushMessage!: string;
  success!: boolean;
}

export class SendLayoutNominatorNotificationResponse {
  @Type(() => LayoutNominatorNotificationResultApiDto)
  results!: LayoutNominatorNotificationResultApiDto[];
}

export class CreateKeywordAdminRequest {
  keywordType!: KeywordType;
  matchType!:
    | 'WHITE_SPACE_SEPERATED'
    | 'CONTAINS'
    | 'EXACT'
    | 'REMOVE_WHITE_SPACE';
  keyword!: string;
}

export class TestKeywordAdminRequest {
  type!: KeywordType;
  text!: string;
}

export class TestKeywordAdminResponse {
  matches!: string[];
}

export class CreateFeatureFlagRequest {
  key!: string;
  country!: Country;
  deviceType?: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  minimumAppVersion?: string;
  enabled!: boolean;
  @Type(() => Date)
  enabledUntil?: Date;
}

export class FeatureFlagForAdminApiDto {
  id!: number;
  key!: string;
  country!: Country;
  deviceType?: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  minimumAppVersion?: string;
  enabled!: boolean;
  @Type(() => Date)
  enabledUntil?: Date;
}

export class CreateContactReplyAdminRequest {
  content!: string;
  status!: ContactReplyStatus;
}

export class ContactAttachmentAdminApiDto {
  id!: string;
  contactId!: string;
  adminId?: string;
  fileUrl!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListContactAttachmentAdminResponse {
  @Type(() => ContactAttachmentAdminApiDto)
  contactAttachments!: ContactAttachmentAdminApiDto[];
}

export class CreateContactTagAdminRequest {
  contactId!: string;
  texts!: string[];
}

export class ContactTagAdminApiDto {
  id!: string;
  contactId!: string;
  text!: string;
  sequence!: number;
}

export class ListContactTagAdminResponse {
  @Type(() => ContactTagAdminApiDto)
  contactTags!: ContactTagAdminApiDto[];
  nextPage?: number;
}

export class CoinSubscribeRefundAdminRequest {
  @Type(() => Date)
  refundAt!: Date;
}

export class CoinRevokeFreeAdminRequest {
  userId!: string;
  reason!: string;
}

export class CoinBundleRefundAdminRequest {
  userId!: string;
}

export class CoinBundleRefundAdminResponse {
  refundPrice!: number;
}

export class CoinTransactionHistoryFindConditionAdminRequest {
  userId?: string;
  email?: string;
  username?: string;
}

export class CoinTransactionAdminApiDto {
  id!: string;
  amount!: number;
  balance?: number;
  type!: 'DEPOSIT' | 'WITHDRAWAL';
  @Type(() => Date)
  createdAt!: Date;
  depositType?:
    | 'PURCHASE_REFUND'
    | 'SUBSCRIBE_REFUND'
    | 'OPEN_STORE_PURCHASE'
    | 'OPEN_STORE_PURCHASE_BONUS'
    | 'OFFERWALL_REWARD'
    | 'ADMIN'
    | 'PRO_DAILY_REWARD_240911'
    | 'INTERNAL_TEST'
    | 'ADMIN_REWARD';
  withdrawalType?:
    | 'PURCHASE'
    | 'SUBSCRIBE'
    | 'COIN_EXPIRE'
    | 'COIN_REFUND'
    | 'ADMIN';
  purchaseId?: string;
  storeType?: OpenStoreType;
  @Type(() => Date)
  expiredAt?: Date;
}

export class ListCoinTransactionHistoryByAdminResponse {
  @Type(() => CoinTransactionAdminApiDto)
  transactions!: CoinTransactionAdminApiDto[];
  nextCursor?: number;
}

export class CoinDepositAdminRequest {
  userId!: string;
  amount!: number;
  @Type(() => Date)
  expireAt?: Date;
  reason!: string;
  type!: AdminCoinDepositType;
}

export class CreateCoinProductRequest {
  id?: string;
  country!: Country;
  name!: string;
  price!: number;
  originalPrice!: number;
  type!: CoinProductType;
  durationDays?: number;
  status!: ProductStatus;
  @Type(() => Date)
  availableUntil?: Date;
}

export class CoinProductAdminPurchaseRequest {
  userId!: string;
  productId!: string;
}

export class CreateChatMABExperimentRequest {
  id!: string;
  seed!: string;
  @Type(() => IntRange)
  range!: IntRange;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt!: Date;
  description?: string;
  @Type(() => ChatMABConfig)
  config!: ChatMABConfig;
  @Type(() => ChatMABExperimentBucket)
  bucketList!: ChatMABExperimentBucket[];
  @Type(() => MABPrerequisite, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: SeedRangePrerequisite, name: 'SeedRange' },
        { value: GenderPrerequisite, name: 'Gender' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  prerequisites?: (GenderPrerequisite | SeedRangePrerequisite)[];
}

export class CreateCharacterFacialImageApiDto {
  url!: string;
  previewUrl!: string;
  expression!: CharacterExpression;
}

export class CreateCharacterFacialAdminApiDto {
  coinProductId?: string;
  @Type(() => CreateCharacterFacialImageApiDto)
  images!: CreateCharacterFacialImageApiDto[];
  index!: number;
  defaultExpression!: CharacterExpression;
  description!: string;
  title!: string;
  isFree!: boolean;
  previewCount?: number;
}

export class UploadBannerImageRequest {
  files!: Blob[];
}

export class UploadBannerImageResponse {
  urls!: string[];
}

export class AppPushApiDto {
  title!: string;
  body!: string;
  bodyImageUrl?: string;
  navigateName!: string;
  navigateParam!: object;
}

export class AppPushAdminSendRequest {
  userIds!: string[];
  pushType!: PushType;
  @Type(() => AppPushApiDto)
  body!: AppPushApiDto;
}

export class AppPushAdminSendResultApiDto {
  success!: boolean;
  message!: string;
  userId!: string;
}

export class AppPushAdminSendResultResponse {
  @Type(() => AppPushAdminSendResultApiDto)
  results!: AppPushAdminSendResultApiDto[];
}

export class AppPushAdminSendAnnouncementRequest {
  userIds!: string[];
  message!: string;
  announcementId!: number;
}

export class AnnouncementAdminApiDto {
  id!: number;
  title!: string;
  content!: string;
  country!: Country;
  publishedAt!: string;
  isDraft!: boolean;
  showBanner!: boolean;
  @Type(() => AnnouncementABExperimentConditionAdminApiDto)
  abExperimentIdBucketMap?: AnnouncementABExperimentConditionAdminApiDto[];
  targetDevice?: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  imageUrl?: string;
  minimumAppVersion?: string;
}

export class UploadAnnouncementImageRequest {
  files!: Blob[];
}

export class UploadAnnouncementImageResponse {
  urls!: string[];
}

export class CreateABUserRequest {
  userId!: string;
  experimentId!: string;
  experimentBucket!: string;
}

export class CreateABExperimentAdminRequest {
  id!: string;
  seed!: string;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt!: Date;
  targetCountry!: Country;
  type!: ABExperimentType;
  metadataByBucket!: object;
  description?: string;
  minimumAppVersion?: string;
  @Type(() => Date)
  minimumUserCreatedAt?: Date;
  @Type(() => MABPrerequisite, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: SeedRangePrerequisite, name: 'SeedRange' },
        { value: GenderPrerequisite, name: 'Gender' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  prerequisites?: SeedRangePrerequisite[];
}

export class ABExperimentByDeviceAdminApiDto {
  id!: string;
  seed!: string;
  @Type(() => Date)
  startAt!: Date;
  @Type(() => Date)
  endAt!: Date;
  targetCountry!: Country;
  rangeByBucket!: object;
  description?: string;
}

export class PatchUserProfileRequest {
  name?: string;
  nickname?: string;
  username?: string;
  profileImageUrl?: string;
  gender?: Gender;
  birthdate?: string;
  description?: string;
  marketingOptIn?: boolean;
  sexualContentsAllowed?: boolean;
  isBackgroundEnabled?: boolean;
}

export class PatchUserChatProfileRequest {
  name?: string;
  profileImageUrl?: string;
  description?: string;
}

export class UpdatePlotStatusRequest {
  status!: UpdatePlotStatusRequestStatus;
}

export class UpdatePlotPrivateRequest {
  isPrivate!: boolean;
}

export class PatchCharacterFacialSettingRequest {
  setId?: string;
  isEnabled?: boolean;
}

export class PatchUserCharacterVoiceSettingRequest {
  autoGenerate?: boolean;
}

export class UpdateSupportCategorySequenceAdminApiDto {
  id!: string;
  sequence!: number;
}

export class UpdateSupportCategorySequenceAdminRequest {
  @Type(() => UpdateSupportCategorySequenceAdminApiDto)
  categories!: UpdateSupportCategorySequenceAdminApiDto[];
}

export class UpdateFeatureFlagRequest {
  country?: Country;
  deviceType?: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  minimumAppVersion?: string;
  enabled?: boolean;
  @Type(() => Date)
  enabledUntil?: Date;
}

export class UpdateFaqSequenceAdminApiDto {
  id!: string;
  sequence!: number;
}

export class UpdateFaqSequenceAdminRequest {
  @Type(() => UpdateFaqSequenceAdminApiDto)
  faqs!: UpdateFaqSequenceAdminApiDto[];
}

export class UpdateFaqFavoriteSequenceAdminApiDto {
  faqId!: string;
  sequence!: number;
}

export class UpdateFaqFavoriteSequenceAdminRequest {
  @Type(() => UpdateFaqFavoriteSequenceAdminApiDto)
  faqFavorites!: UpdateFaqFavoriteSequenceAdminApiDto[];
}

export class UpdateContactAdminRequest {
  status!: ContactStatus;
}

export class ContactAdminApiDto {
  id!: string;
  mainCategoryId!: string;
  subCategoryId!: string;
  userId!: string;
  adminId?: string;
  title!: string;
  content!: string;
  status!: ContactStatus;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class VoiceTagApiDto {
  text!: string;
  color!: string;
}

export class VoiceTemplateApiDto {
  id!: string;
  name!: string;
  gender!: Gender;
  ageGroup!: VoiceAgeGroup;
  @Type(() => VoiceSettingApiDto)
  setting!: VoiceSettingApiDto;
  @Type(() => VoiceTagApiDto)
  tags!: VoiceTagApiDto[];
}

export class ListVoiceTemplatesResponse {
  @Type(() => VoiceTemplateApiDto)
  templates!: VoiceTemplateApiDto[];
}

export class GetVoiceSettingRangesResponse {
  pitchShift!: number[];
  pitchVariance!: number[];
  speed!: number[];
}

export class GetVoicePriceRangesResponse {
  priceRanges!: number[];
}

export class UserApiDto {
  id!: string;
  nickname!: string;
  username!: string;
  profileImageUrl?: string;
  description?: string;
  isActive!: boolean;
}

export class CreatorStatsApiDto {
  followingCount!: number;
  followerCount!: number;
  plotCount!: number;
  plotInteractionCount!: number;
  voicePlaySeconds!: number;
  storyCount!: number;
}

export class CreatorFollowApiDto {
  isNotificationEnabled!: boolean;
}

export class GetCreatorFollowResponse {
  @Type(() => CreatorFollowApiDto)
  follow?: CreatorFollowApiDto;
}

export class FollowingCreatorApiDto {
  isNotificationEnabled!: boolean;
  @Type(() => UserApiDto)
  followingCreator!: UserApiDto;
  isFollowingMe!: boolean;
  isFollowedByMe!: boolean;
}

export class ListFollowingCreatorResponse {
  @Type(() => FollowingCreatorApiDto)
  creators!: FollowingCreatorApiDto[];
  nextCursor?: number;
}

export class FollowerApiDto {
  isNotificationEnabled!: boolean;
  @Type(() => UserApiDto)
  follower!: UserApiDto;
  isFollowingMe!: boolean;
  isFollowedByMe!: boolean;
}

export class ListFollowerResponse {
  @Type(() => FollowerApiDto)
  creators!: FollowerApiDto[];
  nextCursor?: number;
}

export class ErrorResponseData {}

export class ErrorResponse {
  code!: ExceptionCode;
  status!: number;
  message?: string;
  @Type(() => ErrorResponseData)
  data?: ErrorResponseData;
}

export class UserMeResponseTier {
  type!: 'NORMAL' | 'PRO';
  isTrial!: boolean;
  @Type(() => Date)
  expiredAt?: Date;
}

export class UserMeResponse {
  id!: string;
  /**
   * @example 김종윤
   */
  name!: string;
  /**
   * @example dafunk
   */
  nickname!: string;
  /**
   * @example dafunk
   */
  username!: string;
  /**
   * @example https://avatars.githubusercontent.com/u/12345678?v=4
   */
  profileImageUrl?: string;
  /**
   * @example 안녕하세요 dafunk입니다
   */
  description?: string;
  gender!: Gender;
  birthdate?: string;
  country!: Country;
  isAnonymous!: boolean;
  marketingOptIn!: boolean;
  sexualContentsAllowed!: boolean;
  isBackgroundEnabled!: boolean;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => UserMeResponseTier)
  tier!: UserMeResponseTier;
}

export class UserExternalRelationApiDto {
  id!: number;
  userId!: string;
  issuer!: TokenIssuer;
  externalId!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListUserExternalRelationResponse {
  @Type(() => UserExternalRelationApiDto)
  userExternalRelations!: UserExternalRelationApiDto[];
}

export class CreatorStatsWithDeltaApiDtoPlotStatDeltaApiDto {
  plotId!: string;
  interactionCountIncrease!: number;
  voicePlaySecondsIncrease!: number;
}

export class CreatorStatsWithDeltaApiDto {
  followingCount!: number;
  followerCount!: number;
  plotCount!: number;
  privatePlotCount!: number;
  plotInteractionCount!: number;
  voicePlaySeconds!: number;
  followerCountIncrease!: number;
  plotInteractionCountIncrease!: number;
  voicePlaySecondsIncrease!: number;
  @Type(() => CreatorStatsWithDeltaApiDtoPlotStatDeltaApiDto)
  plotStats!: CreatorStatsWithDeltaApiDtoPlotStatDeltaApiDto[];
}

export class GetFollowingCreatorCountResponse {
  count!: number;
}

export class ListBlockedUserResponse {
  @Type(() => UserApiDto)
  blockedUsers!: UserApiDto[];
}

export class UsernameResponse {
  username!: string;
}

export class UserChatProfileListResponse {
  @Type(() => UserChatProfileApiDto)
  userChatProfiles!: UserChatProfileApiDto[];
  nextCursor?: number;
}

export class SupportCategoryWithChildrenApiDto {
  id!: string;
  name!: string;
  description?: string;
  @Type(() => SupportCategoryApiDto)
  children!: SupportCategoryApiDto[];
}

export class ListSupportCategoryResponse {
  @Type(() => SupportCategoryWithChildrenApiDto)
  supportCategories!: SupportCategoryWithChildrenApiDto[];
}

export class StoryProfileApiDto {
  id!: string;
  name!: string;
  imageUrl?: string;
}

export class StoryApiDto {
  id!: string;
  title!: string;
  description!: string;
  coverImageUrl!: string;
  @Type(() => StoryProfileApiDto)
  storyCreator!: StoryProfileApiDto;
  episodeCount!: number;
  hashtags!: string[];
  isRecentlyUpdated!: boolean;
  viewCount!: number;
  status!: StoryStatus;
}

export class ListStoryResponse {
  @Type(() => StoryApiDto)
  stories!: StoryApiDto[];
  nextCursor?: string;
  totalStoryCount!: number;
  totalFavoriteStoryCount!: number;
}

export class StoryEpisodeApiDto {
  id!: string;
  title!: string;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  publishedAt?: Date;
  isRecentlyUpdated!: boolean;
}

export class GetStoryResponse {
  id!: string;
  title!: string;
  description!: string;
  coverImageUrl!: string;
  hashtags!: string[];
  @Type(() => StoryEpisodeApiDto)
  episodes!: StoryEpisodeApiDto[];
  @Type(() => StoryProfileApiDto)
  storyCreator!: StoryProfileApiDto;
  @Type(() => StoryProfileApiDto)
  plotCreator!: StoryProfileApiDto;
  @Type(() => StoryProfileApiDto)
  plot!: StoryProfileApiDto;
  isRecentlyUpdated!: boolean;
  isFavorite!: boolean;
  isPushAllowed!: boolean;
  viewCount!: number;
  status!: StoryStatus;
}

export class ListRecentlyStoryResponse {
  @Type(() => StoryApiDto)
  stories!: StoryApiDto[];
  nextCursor?: number;
}

export class StoryContentApiDto {
  sender!: SenderType;
  content!: string;
}

export class GetStoryEpisodeWithContentsResponse {
  id!: string;
  title!: string;
  @Type(() => StoryContentApiDto)
  contents!: StoryContentApiDto[];
}

export class ListStoryCurationResponse {
  @Type(() => StoryApiDto)
  stories!: StoryApiDto[];
}

export class ListStoryByCreatorIdResponse {
  @Type(() => StoryApiDto)
  stories!: StoryApiDto[];
  nextCursor?: number;
  totalStoryCount!: number;
}

export class CountStoryResponse {
  storyCount!: number;
  favoriteStoryCount!: number;
  recentlyStoryCount!: number;
}

export class ListRoomResponseRoomApiDto {
  id!: string;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => LastMessageApiDto)
  lastMessage?: LastMessageApiDto;
  isActive!: boolean;
  title?: string;
  unreadCount!: number;
  @Type(() => PlotApiDto)
  plot!: PlotApiDto;
  @Type(() => Date)
  burningModeEndTime?: Date;
  isPinned!: boolean;
}

export class ListRoomResponse {
  @Type(() => ListRoomResponseRoomApiDto)
  rooms!: ListRoomResponseRoomApiDto[];
  nextCursor?: number;
}

export class RecommendedMessageHistoryResponseReply {
  id!: string;
  content!: string;
}

export class RecommendedMessageHistoryResponseReplyHistory {
  @Type(() => RecommendedMessageHistoryResponseReply)
  replies!: RecommendedMessageHistoryResponseReply[];
}

export class RecommendedMessageHistoryResponse {
  isAbusing!: boolean;
  @Type(() => RecommendedMessageHistoryResponseReplyHistory)
  messages!: RecommendedMessageHistoryResponseReplyHistory[];
}

export class GetPlotIdResponse {
  plotId!: string;
}

export class ListMessageResponse {
  @Type(() => MessageApiDto)
  messages!: MessageApiDto[];
  nextCursor?: string;
}

export class ListCandidateResponse {
  @Type(() => CandidateApiDto)
  candidates!: CandidateApiDto[];
  nextCursor?: string;
}

export class CanCreateMessageVoiceResponse {
  result!: 'OK' | 'EMPTY_MESSAGE' | 'TOO_LONG_MESSAGE';
}

export class FacialImage {
  messageId!: string;
  imageUrl!: string;
}

export class ListRoomFacialImageResponse {
  @Type(() => FacialImage)
  facialImages!: FacialImage[];
  nextCursor?: string;
}

export class Image {
  messageId!: string;
  status!: MessageBackgroundStatus;
  imageUrl?: string;
}

export class GetBackgroundImagesResponse {
  @Type(() => Image)
  backgroundImages!: Image[];
  nextCursor?: string;
}

export class ListSavedRoomResponseSavedRoomApiDto {
  id!: string;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => LastMessageApiDto)
  lastMessage?: LastMessageApiDto;
  isActive!: boolean;
  title?: string;
  unreadCount!: number;
  @Type(() => PlotApiDto)
  plot!: PlotApiDto;
}

export class ListSavedRoomResponse {
  @Type(() => ListSavedRoomResponseSavedRoomApiDto)
  rooms!: ListSavedRoomResponseSavedRoomApiDto[];
  nextCursor?: number;
}

export class GetSavedRoomStatusResponse {
  count!: number;
  maxCount?: number;
}

export class RecommendedMessageAvailableTimeResponse {
  @Type(() => Date)
  availableAfter!: Date;
  @Type(() => Date)
  lastUsedTime!: Date;
}

export class PopupApiDto {
  id!: string;
  imageUrl!: string;
  @Type(() => ClickAction, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: ProPurchaseModal, name: 'proPurchaseModal' },
        { value: ExternalLink, name: 'externalLink' },
        { value: Navigate, name: 'navigate' },
        { value: EventModal, name: 'eventModal' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  clickAction!: EventModal | ExternalLink | Navigate | ProPurchaseModal;
}

export class ListPopupResponse {
  @Type(() => PopupApiDto)
  popups!: PopupApiDto[];
}

export class ListPolicyResponse {
  @Type(() => PolicySummaryApiDto)
  policies!: PolicySummaryApiDto[];
}

export class PolicyApiDto {
  content!: string;
  applyDate!: string;
}

export class PagePlotResponse {
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
  nextCursor?: string;
}

export class PlotRecommendResponse {
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
}

export class IsPlotLikedResponse {
  isLiked!: boolean;
}

export class CharacterVoiceSettingWithDraftApiDto {
  templateId!: string;
  @Type(() => VoiceSettingApiDto)
  setting!: VoiceSettingApiDto;
  @Type(() => CharacterVoiceSettingApiDto)
  draft?: CharacterVoiceSettingApiDto;
  enabled!: boolean;
}

export class GetOriginalProfileImageResponse {
  imageUrl!: string;
}

export class PagePlotSearchResponse {
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
  nextCursor?: string;
}

export class GetPlotCountByKeywordResponse {
  count!: number;
}

export class ListPlotSearchKeywordResponse {
  keywords!: string[];
}

export class ListPlotRecommendedKeywordResponse {
  keywords!: string[];
}

export class ListPlotSearchAutoCompleteResponseHashtag {
  hashtag!: string;
  count!: number;
}

export class ListPlotSearchAutoCompleteResponse {
  @Type(() => ListPlotSearchAutoCompleteResponseHashtag)
  hashtags!: ListPlotSearchAutoCompleteResponseHashtag[];
}

export class PlotProfileImageStyleResponse {
  id!: string;
  model!: string;
  name!: string;
  price!: number;
  thumbnail!: string;
  isZetaModel!: boolean;
}

export class GetPlotProfileImageGenerationSavedResultResponse {
  id!: string;
  imageUrl!: string;
  prompt!: string;
  seed!: number;
  @Type(() => PlotProfileImageStyleResponse)
  style!: PlotProfileImageStyleResponse;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  expiredAt!: Date;
}

export class GetPlotProfileImageGenerationSavedResultListResponse {
  @Type(() => GetPlotProfileImageGenerationSavedResultResponse)
  profileImages!: GetPlotProfileImageGenerationSavedResultResponse[];
  nextCursor?: string;
}

export class GetPlotProfileImageGenerationSavedResultCountResponse {
  totalCount!: number;
}

export class PlotRankingApiDto {
  id!: string;
  imageUrl!: string;
  name!: string;
  hashtags!: string[];
  greeting!: string;
  @Type(() => PlotCharacterApiDto)
  characters!: PlotCharacterApiDto[];
  @Type(() => PlotIntroApiDto)
  intros!: PlotIntroApiDto[];
  shortDescription?: string;
  @Type(() => PlotCreatorApiDto)
  creator!: PlotCreatorApiDto;
  interactionCount!: number;
  interactionCountWithRegen!: number;
  verified!: boolean;
  @Type(() => Date)
  updatedAt!: Date;
  rank!: number;
  rankDiff!: number;
  isNew!: boolean;
  supportedFeatures!: PlotFeature[];
}

export class ListPlotRankingResponse {
  @Type(() => PlotRankingApiDto)
  rankings!: PlotRankingApiDto[];
}

export class ListPlotResponse {
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
}

export class GetPlotProfileImageGenerationResultResponse {
  id!: string;
  prompt!: string;
  seed!: number;
  @Type(() => PlotProfileImageStyleResponse)
  style!: PlotProfileImageStyleResponse;
  imageUrl!: string;
  saved!: boolean;
  @Type(() => Date)
  createdAt!: Date;
}

export class GetPlotProfileImageGenerationResultListResponse {
  @Type(() => GetPlotProfileImageGenerationResultResponse)
  profileImages!: GetPlotProfileImageGenerationResultResponse[];
  nextCursor?: string;
}

export class TagTermTranslationResponse {
  term!: string;
  translatedTerm!: string;
}

export class GetPlotProfileImagePredefinedTagsResponse {
  @Type(() => TagTermTranslationResponse)
  category!: TagTermTranslationResponse;
  @Type(() => TagTermTranslationResponse)
  tags!: TagTermTranslationResponse[];
}

export class GetPlotProfileImagePredefinedTagsListResponse {
  @Type(() => GetPlotProfileImagePredefinedTagsResponse)
  tags!: GetPlotProfileImagePredefinedTagsResponse[];
}

export class GetPlotProfileImageGenerationStyleListResponse {
  @Type(() => PlotProfileImageStyleResponse)
  styles!: PlotProfileImageStyleResponse[];
}

export class GetPlotProfileImageGenerationJobResponse {
  status!:
    | 'COMPLETE'
    | 'IN_PROGRESS'
    | 'SERVER_ERROR'
    | 'ABUSING_ERROR'
    | 'INSUFFICIENT_COIN_ERROR';
  profileImageResultId?: string;
}

export class RecentPreReleasePlotResponse {
  @Type(() => PlotForCreatorApiDto)
  recentPlot?: PlotForCreatorApiDto;
  preReleasePlotCount!: number;
}

export class OnboardingPlotMissionApiDto {
  content!: string;
  userInput!: string;
}

export class OnboardingPlotApiDto {
  keyword!: string;
  introduceMessage!: string;
  @Type(() => PlotApiDto)
  plot!: PlotApiDto;
  alreadyChat!: boolean;
  @Type(() => OnboardingPlotMissionApiDto)
  missions!: OnboardingPlotMissionApiDto[];
}

export class ListOnboardingPlotResponse {
  @Type(() => OnboardingPlotApiDto)
  plots!: OnboardingPlotApiDto[];
  canSkip!: boolean;
}

export class PagePlotLikedResponse {
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
  nextCursor?: number;
}

export class CountPlotLikedResponse {
  count!: number;
}

export class GetPlotCountByHashtagResponse {
  count!: number;
}

export class ListBlockedHashtagResponse {
  hashtags!: string[];
}

export class PlotDiscoveryApiDto {
  plotId!: string;
  imageUrl!: string;
  name!: string;
  interactionCountWithRegen!: number;
  shortDescription!: string;
  greeting?: string;
  @Type(() => PlotIntroApiDto)
  intros!: PlotIntroApiDto[];
  hashtags!: string[];
  supportedFeatures!: PlotFeature[];
  isLiked!: boolean;
  @Type(() => Date)
  updatedAt!: Date;
}

export class ListPlotDiscoveryResponse {
  @Type(() => PlotDiscoveryApiDto)
  plots!: PlotDiscoveryApiDto[];
}

export class PagePlotForCreatorResponse {
  @Type(() => PlotForCreatorApiDto)
  plots!: PlotForCreatorApiDto[];
  nextCursor?: string;
}

export class CheckPlotNameResponse {
  warnKeywords!: string[];
}

export class BlockedActivePlotApiDto extends BlockedPlotApiDto {
  declare type: 'active';
  name!: string;
  profileImageUrl!: string;
  interactionCountWithRegen!: number;
}

export class BlockedDeletedPlotApiDto extends BlockedPlotApiDto {
  declare type: 'deleted';
}

export class ListBlockedPlotResponse {
  @Type(() => BlockedPlotApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: BlockedDeletedPlotApiDto, name: 'deleted' },
        { value: BlockedActivePlotApiDto, name: 'active' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  blockedPlots!: (BlockedActivePlotApiDto | BlockedDeletedPlotApiDto)[];
}

export class OpenStoreProductApiDto {
  /**
   * 스토어 상품 ID
   */
  id!: string;
  type!: OpenStoreProductApiDtoType;
  name!: string;
  amount!: number;
  bonusAmount!: number;
  price!: number;
  discountedPrice!: number;
  currency!: string;
}

export class ListProductsResponse {
  @Type(() => OpenStoreProductApiDto)
  products!: OpenStoreProductApiDto[];
}

export class OpenApiUsageResponseUsage {
  date!: string;
  totalCount!: number;
  inputTokenLength!: number;
  outputTokenLength!: number;
}

export class OpenApiUsageResponse {
  @Type(() => OpenApiUsageResponseUsage)
  usages!: OpenApiUsageResponseUsage[];
}

export class Message {
  senderType!: SenderType;
  message!: string;
}

export class OnboardingExampleChatApiDto {
  plotName!: string;
  imageUrl!: string;
  backgroundImageUrl!: string;
  @Type(() => Message)
  messageList!: Message[];
}

export class GetOnboardingExampleChatResponse {
  @Type(() => OnboardingExampleChatApiDto)
  onboardingExampleChats?: OnboardingExampleChatApiDto[];
}

export class TapjoyOfferwallRewardRequest {
  snuid!: string;
  currency!: number;
  mac_address!: string;
  id!: string;
  verifier!: string;
}

export class NuttyUserApiDto {
  migrationStatus!: 'NOT_REQUESTED' | 'REQUESTED' | 'PROCESSING' | 'MIGRATED';
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  migrationFinishedAt?: Date;
  refundRequested!: boolean;
}

export class RenderedLayoutSectionApiDtoBigProfile extends RenderedLayoutSectionApiDto {
  declare type: 'BigProfile';
  title!: string;
  subtitle?: string;
  highlightText?: string;
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
}

export class RenderedLayoutSectionApiDtoDiscoveryRecommendedRefreshView extends RenderedLayoutSectionApiDto {
  declare type: 'DiscoveryRecommendedRefreshView';
  title!: string;
  subtitle?: string;
  highlightText?: string;
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
}

export class RenderedLayoutSectionApiDtoPlotPoolMoreView extends RenderedLayoutSectionApiDto {
  declare type: 'PlotPoolMoreView';
  title!: string;
  subtitle?: string;
  highlightText?: string;
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
  plotPoolId!: string;
}

export class RenderedLayoutSectionApiDtoRankingEntry {
  rank!: number;
  @Type(() => PlotApiDto)
  plot!: PlotApiDto;
}

export class RenderedLayoutSectionApiDtoRanking extends RenderedLayoutSectionApiDto {
  declare type: 'Ranking';
  title!: string;
  subtitle?: string;
  highlightText?: string;
  @Type(() => RenderedLayoutSectionApiDtoRankingEntry)
  plots!: RenderedLayoutSectionApiDtoRankingEntry[];
}

export class RenderedLayoutSectionApiDtoRecentlyCreatedWithMoreView extends RenderedLayoutSectionApiDto {
  declare type: 'RecentlyCreatedWithMoreView';
  title!: string;
  subtitle?: string;
  highlightText?: string;
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
}

export class RenderedLayoutSectionApiDtoRecommendedReplyPlotReplies {
  @Type(() => PlotApiDto)
  plot!: PlotApiDto;
  replies!: string[];
}

export class RenderedLayoutSectionApiDtoRecommendedReply extends RenderedLayoutSectionApiDto {
  declare type: 'RecommendedReply';
  title!: string;
  subtitle?: string;
  highlightText?: string;
  @Type(() => RenderedLayoutSectionApiDtoRecommendedReplyPlotReplies)
  plotReplies!: RenderedLayoutSectionApiDtoRecommendedReplyPlotReplies[];
}

export class RenderedLayoutSectionApiDtoSmallProfile extends RenderedLayoutSectionApiDto {
  declare type: 'SmallProfile';
  title!: string;
  subtitle?: string;
  highlightText?: string;
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
}

export class GetLayoutResponse {
  id!: string;
  requestId!: string;
  @Type(() => RenderedLayoutSectionApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: RenderedLayoutSectionApiDtoBigProfile, name: 'BigProfile' },
        {
          value: RenderedLayoutSectionApiDtoSmallProfile,
          name: 'SmallProfile',
        },
        {
          value: RenderedLayoutSectionApiDtoRecommendedReply,
          name: 'RecommendedReply',
        },
        { value: RenderedLayoutSectionApiDtoRanking, name: 'Ranking' },
        {
          value: RenderedLayoutSectionApiDtoRecentlyCreatedWithMoreView,
          name: 'RecentlyCreatedWithMoreView',
        },
        {
          value: RenderedLayoutSectionApiDtoPlotPoolMoreView,
          name: 'PlotPoolMoreView',
        },
        {
          value: RenderedLayoutSectionApiDtoDiscoveryRecommendedRefreshView,
          name: 'DiscoveryRecommendedRefreshView',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  sections!: (
    | RenderedLayoutSectionApiDtoBigProfile
    | RenderedLayoutSectionApiDtoDiscoveryRecommendedRefreshView
    | RenderedLayoutSectionApiDtoPlotPoolMoreView
    | RenderedLayoutSectionApiDtoRanking
    | RenderedLayoutSectionApiDtoRecentlyCreatedWithMoreView
    | RenderedLayoutSectionApiDtoRecommendedReply
    | RenderedLayoutSectionApiDtoSmallProfile
  )[];
  @Type(() => Date)
  updatedAt!: Date;
}

export class GetRenderedLayoutSectionResponse {
  requestId!: string;
  @Type(() => RenderedLayoutSectionApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: RenderedLayoutSectionApiDtoBigProfile, name: 'BigProfile' },
        {
          value: RenderedLayoutSectionApiDtoSmallProfile,
          name: 'SmallProfile',
        },
        {
          value: RenderedLayoutSectionApiDtoRecommendedReply,
          name: 'RecommendedReply',
        },
        { value: RenderedLayoutSectionApiDtoRanking, name: 'Ranking' },
        {
          value: RenderedLayoutSectionApiDtoRecentlyCreatedWithMoreView,
          name: 'RecentlyCreatedWithMoreView',
        },
        {
          value: RenderedLayoutSectionApiDtoPlotPoolMoreView,
          name: 'PlotPoolMoreView',
        },
        {
          value: RenderedLayoutSectionApiDtoDiscoveryRecommendedRefreshView,
          name: 'DiscoveryRecommendedRefreshView',
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  section!:
    | RenderedLayoutSectionApiDtoBigProfile
    | RenderedLayoutSectionApiDtoDiscoveryRecommendedRefreshView
    | RenderedLayoutSectionApiDtoPlotPoolMoreView
    | RenderedLayoutSectionApiDtoRanking
    | RenderedLayoutSectionApiDtoRecentlyCreatedWithMoreView
    | RenderedLayoutSectionApiDtoRecommendedReply
    | RenderedLayoutSectionApiDtoSmallProfile;
}

export class InfinitePlotsResponse {
  requestId!: string;
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
  nextCursor?: string;
}

export class FeatureFlagResponse {
  enabled!: boolean;
}

export class FaqSummaryApiDto {
  id!: string;
  @Type(() => SupportCategoryApiDto)
  mainCategory!: SupportCategoryApiDto;
  @Type(() => SupportCategoryApiDto)
  subCategory!: SupportCategoryApiDto;
  title!: string;
}

export class ListFaqSummaryResponse {
  @Type(() => FaqSummaryApiDto)
  faqs!: FaqSummaryApiDto[];
}

export class FaqApiDto {
  id!: string;
  @Type(() => SupportCategoryApiDto)
  mainCategory!: SupportCategoryApiDto;
  @Type(() => SupportCategoryApiDto)
  subCategory!: SupportCategoryApiDto;
  title!: string;
  content!: string;
}

export class ListFaqResponse {
  @Type(() => FaqApiDto)
  faqs!: FaqApiDto[];
}

export class ContactSummaryApiDto {
  id!: string;
  @Type(() => SupportCategoryApiDto)
  mainCategory!: SupportCategoryApiDto;
  @Type(() => SupportCategoryApiDto)
  subCategory!: SupportCategoryApiDto;
  title!: string;
  status!: ContactStatus;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListContactResponse {
  @Type(() => ContactSummaryApiDto)
  contacts!: ContactSummaryApiDto[];
  nextPage?: number;
}

export class ListContactReplyResponse {
  @Type(() => ContactReplyApiDto)
  contactReplies!: ContactReplyApiDto[];
}

export class CountContactResponse {
  count!: number;
}

export class CoinWithdrawalApiDto {
  id!: string;
  amount!: number;
  type!: 'PURCHASE' | 'SUBSCRIBE' | 'COIN_EXPIRE' | 'COIN_REFUND' | 'ADMIN';
  description!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListCoinWithdrawalResponse {
  @Type(() => CoinWithdrawalApiDto)
  withdrawals!: CoinWithdrawalApiDto[];
  nextCursor?: number;
}

export class CoinExpirationApiDto {
  amount!: number;
  @Type(() => Date)
  expiredAt!: Date;
}

export class ListCoinExpirationResponse {
  @Type(() => CoinExpirationApiDto)
  expirations!: CoinExpirationApiDto[];
  nextCursor?: number;
}

export class CoinDepositApiDto {
  id!: string;
  amount!: number;
  type!:
    | 'PURCHASE_REFUND'
    | 'SUBSCRIBE_REFUND'
    | 'OPEN_STORE_PURCHASE'
    | 'OPEN_STORE_PURCHASE_BONUS'
    | 'OFFERWALL_REWARD'
    | 'ADMIN'
    | 'PRO_DAILY_REWARD_240911'
    | 'INTERNAL_TEST'
    | 'ADMIN_REWARD';
  description!: string;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  expiredAt?: Date;
}

export class ListCoinDepositResponse {
  @Type(() => CoinDepositApiDto)
  deposits!: CoinDepositApiDto[];
  nextCursor?: number;
}

export class CoinDailyRewardLeftResponse {
  leftAttempts!: number;
}

export class CoinDailyRewardAmountResponse {
  amount!: number;
}

export class CoinBalanceResponse {
  balance!: number;
}

export class CoinProductApiDto {
  id!: string;
  name!: string;
  price!: number;
  discountedPrice!: number;
  type!: CoinProductType;
  durationDays?: number;
}

export class ListCoinProductsResponse {
  @Type(() => CoinProductApiDto)
  products!: CoinProductApiDto[];
}

export class CharacterSkinApiDto {
  id!: string;
  originalPrice!: number;
  price!: number;
  selectable!: boolean;
  selected!: boolean;
  imageUrl!: string;
  title!: string;
  previewAllowed!: boolean;
}

export class ListCharacterSkinResponse {
  @Type(() => CharacterSkinApiDto)
  skins!: CharacterSkinApiDto[];
}

export class SelectedCharacterSkinApiDto {
  id!: string;
  title!: string;
  imageUrl!: string;
}

export class CharacterFacialImageApiDto {
  imageUrl!: string;
  isPreview!: boolean;
}

export class CharacterFacialSetApiDto {
  id!: string;
  originalPrice!: number;
  price!: number;
  isPurchased!: boolean;
  selected!: boolean;
  @Type(() => CharacterFacialImageApiDto)
  images!: CharacterFacialImageApiDto[];
  previewCount!: number;
  title!: string;
  isLimitedEdition!: boolean;
}

export class ListCharacterFacialSetResponse {
  @Type(() => CharacterFacialSetApiDto)
  sets!: CharacterFacialSetApiDto[];
}

export class CharacterFacialSettingApiDto {
  setId?: string;
  isEnabled!: boolean;
}

export class UserCharacterVoiceSettingApiDto {
  autoGenerate!: boolean;
  needRefresh!: boolean;
}

export class VoiceApiDto {
  voiceUrl!: string;
  durationSeconds!: number;
}

export class BannerApiDto {
  id!: number;
  titlePrimary!: string;
  titleSecondary!: string;
  imageUrl?: string;
  priority!: number;
  @Type(() => ClickAction, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: ProPurchaseModal, name: 'proPurchaseModal' },
        { value: ExternalLink, name: 'externalLink' },
        { value: Navigate, name: 'navigate' },
        { value: EventModal, name: 'eventModal' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  clickAction!: EventModal | ExternalLink | Navigate | ProPurchaseModal;
}

export class ListBannerResponse {
  @Type(() => BannerApiDto)
  banners!: BannerApiDto[];
}

export class GetConnectedExternalPlatformsResponse {
  connectedExternalPlatforms!: TokenIssuer[];
}

export class AppPushSettingsApiDto {
  allowPush!: boolean;
  settings!: object;
}

export class AppPushSettingApiDto {
  isEnabled!: boolean;
}

export class AnnouncementSummaryApiDto {
  id!: number;
  title!: string;
  publishedAt!: string;
}

export class ListAnnouncementResponse {
  @Type(() => AnnouncementSummaryApiDto)
  announcements!: AnnouncementSummaryApiDto[];
  nextCursor?: string;
}

export class AnnouncementApiDto {
  id!: number;
  title!: string;
  content!: string;
  publishedAt!: string;
}

export class AnnouncementBannerApiDto {
  id!: number;
  title!: string;
  imageUrl?: string;
}

export class GetBannerAnnouncementResponse {
  @Type(() => AnnouncementBannerApiDto)
  announcement?: AnnouncementBannerApiDto;
}

export class GetABExperimentResponse {
  bucket?: string;
}

export class GetABExperimentByDeviceResponse {
  bucket?: string;
}

export class DevServer {
  name!: string;
  url!: string;
}

export class ListDevServerResponse {
  @Type(() => DevServer)
  devServers!: DevServer[];
}

export class AppPushTokenApiDto {
  userId!: string;
  deviceType!: 'ANDROID' | 'IOS' | 'WEB' | 'PC_WEB';
  deviceId!: string;
  token!: string;
}

export class DebugGetAppPushTokenResponse {
  @Type(() => AppPushTokenApiDto)
  tokens!: AppPushTokenApiDto[];
}

export class ZetaReportApiDto {
  id!: number;
  type!: ZetaReportType;
  userId!: string;
  goodThings?: string;
  badThings?: string;
  email?: string;
  imageUrls!: string[];
  @Type(() => Date)
  createdAt!: Date;
}

export class PageZetaReportResponse {
  @Type(() => ZetaReportApiDto)
  reports!: ZetaReportApiDto[];
  nextCursor?: number;
}

export class WithdrawalReportApiDto {
  id!: number;
  userId!: string;
  type!: WithdrawalReportType;
  content!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class PageWithdrawalReportResponse {
  @Type(() => WithdrawalReportApiDto)
  reports!: WithdrawalReportApiDto[];
  nextCursor?: number;
}

export class VoiceTemplateTagAdminApiDto {
  id!: number;
  text!: string;
  color!: string;
}

export class VoiceTemplateAdminApiDto {
  id!: string;
  supertoneId!: string;
  name!: string;
  gender!: Gender;
  ageGroup!: VoiceAgeGroup;
  genderValue?: number;
  ageValue?: number;
  pitchShift!: number;
  pitchVariance!: number;
  speed!: number;
  @Type(() => VoiceTemplateTagAdminApiDto)
  tags!: VoiceTemplateTagAdminApiDto[];
}

export class ListVoiceTemplatesAdminResponse {
  @Type(() => VoiceTemplateAdminApiDto)
  templates!: VoiceTemplateAdminApiDto[];
}

export class ListVoiceTemplateTagsAdminResponse {
  @Type(() => VoiceTemplateTagAdminApiDto)
  tags!: VoiceTemplateTagAdminApiDto[];
}

export class UserPenaltyResponse {
  type!: UserProfilePenaltyType;
  level!: PenaltyLevel;
  @Type(() => Date)
  createdAt!: Date;
  blockDays?: number;
}

export class ListUserPenaltyResponse {
  @Type(() => UserPenaltyResponse)
  penalties!: UserPenaltyResponse[];
}

export class ListUserBlockAdminResponse {
  @Type(() => UserBlockAdminApiDto)
  blocks!: UserBlockAdminApiDto[];
}

export class UserReportAdminApiDto {
  id!: number;
  userId!: string;
  reportedUserId!: string;
  type!: ReportType;
  reason?: string;
  status!: ReportStatus;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListUserReportAdminResponse {
  @Type(() => UserReportAdminApiDto)
  reports!: UserReportAdminApiDto[];
  nextCursor?: number;
}

export class GroupedUserReportAdminApiDto {
  reportedUserId!: string;
  reportUserCount!: number;
  reportCount!: number;
  @Type(() => Date)
  lastCreatedAt!: Date;
}

export class ListGroupedUserReportAdminResponse {
  @Type(() => GroupedUserReportAdminApiDto)
  reports!: GroupedUserReportAdminApiDto[];
  nextCursor?: number;
}

export class UserForListAdminApiDto {
  id!: string;
  name!: string;
  username!: string;
  email?: string;
  gender!: Gender;
  timeZone!: object;
  profileImageUrl?: string;
  country!: Country;
  isAnonymous!: boolean;
  birthdate?: string;
  status!: 'ACTIVE' | 'WITHDRAWAL' | 'BANNED';
  isDangerous!: boolean;
  marketingOptIn!: boolean;
  sexualContentsAllowed!: boolean;
  @Type(() => Date)
  createdAt!: Date;
  filteredPlotCount!: number;
  hardDeletedPlotCount!: number;
  interactedPlotCount!: number;
  interactionCount!: number;
  createdPlotCount!: number;
}

export class PageUserForListAdminApiDtoString {
  @Type(() => UserForListAdminApiDto)
  items!: UserForListAdminApiDto[];
  nextCursor?: string;
  pageIndex?: number;
}

export class TossPaymentsCancel {
  cancelAmount!: number;
  cancelReason!: string;
  taxFreeAmount!: number;
  taxExemptionAmount!: number;
  refundableAmount!: number;
  transferDiscountAmount!: number;
  easyPayDiscountAmount!: number;
  canceledAt!: string;
  transactionKey!: string;
  receiptKey?: string;
  cancelStatus!: string;
  cancelRequestId?: string;
}

export class TossPaymentsCard {
  amount!: number;
  issuerCode!: string;
  acquirerCode?: string;
  number!: string;
  installmentPlanMonths!: number;
  approveNo!: string;
  useCardPoint!: boolean;
  cardType!: '신용' | '체크' | '기프트' | '미확인';
  ownerType!: '개인' | '법인' | '미확인';
  acquireStatus!:
    | 'READY'
    | 'REQUESTED'
    | 'COMPLETED'
    | 'CANCEL_REQUESTED'
    | 'CANCELED';
  isInterestFree!: boolean;
  interestPayer?: string;
}

export class TossPaymentsCashReceipt {
  type!: string;
  receiptKey!: string;
  issueNumber!: string;
  receiptUrl!: string;
  amount!: number;
  taxFreeAmount!: number;
}

export class TossPaymentsDiscount {
  amount!: number;
}

export class TossPaymentsFailure {
  code!: string;
  message!: string;
}

export class TossPaymentsCashReceiptItem {
  receiptKey!: string;
  orderId!: string;
  orderName!: string;
  type!: string;
  issueNumber!: string;
  receiptUrl!: string;
  businessNumber!: string;
  transactionType!: string;
  amount!: number;
  taxFreeAmount!: number;
  issueStatus!: string;
  @Type(() => TossPaymentsFailure)
  failure!: TossPaymentsFailure;
  customerIdentityNumber!: string;
  requestedAt!: string;
}

export class TossPaymentsGiftCertificate {
  approveNo!: string;
  settlementStatus!: 'INCOMPLETED' | 'COMPLETED';
}

export class TossPaymentsMobilePhone {
  customerMobilePhone!: string;
  settlementStatus!: 'INCOMPLETED' | 'COMPLETED';
  receiptUrl!: string;
}

export class TossPaymentsOrderDto {
  id!: string;
  userId!: string;
  productId!: string;
  status!: PurchaseStatus;
  @Type(() => Date)
  createdAt!: Date;
}

export class TossPaymentsRefundReceiveAccount {
  bankCode!: string;
  accountNumber!: string;
  holderName!: string;
}

export class TossPaymentsTransfer {
  bankCode!: string;
  settlementStatus!: 'INCOMPLETED' | 'COMPLETED';
}

export class TossPaymentsVirtualAccount {
  accountType!: string;
  accountNumber!: string;
  bankCode!: string;
  customerName!: string;
  dueDate!: string;
  refundStatus!: 'NONE' | 'PENDING' | 'FAILED' | 'PARTIAL_FAILED' | 'COMPLETED';
  expired!: boolean;
  settlementStatus!: 'INCOMPLETED' | 'COMPLETED';
  @Type(() => TossPaymentsRefundReceiveAccount)
  refundReceiveAccount?: TossPaymentsRefundReceiveAccount;
}

export class TossPaymentsTransaction {
  mId?: string;
  transactionKey!: string;
  paymentKey!: string;
  orderId!: string;
  orderName!: string;
  method!:
    | '카드'
    | '가상계좌'
    | '간편결제'
    | '휴대폰'
    | '계좌이체'
    | '문화상품권'
    | '도서문화상품권'
    | '게임문화상품권';
  customerKey?: string;
  useEscrow!: boolean;
  receiptUrl?: string;
  status!:
    | 'READY'
    | 'IN_PROGRESS'
    | 'WAITING_FOR_DEPOSIT'
    | 'DONE'
    | 'CANCELED'
    | 'PARTIAL_CANCELED'
    | 'ABORTED'
    | 'EXPIRED';
  transactionAt!: string;
  currency!: string;
  amount!: number;
  balanceAmount!: number;
  suppliedAmount!: number;
  vat!: number;
  cultureExpense!: boolean;
  taxFreeAmount!: number;
  taxExemptionAmount!: number;
  @Type(() => TossPaymentsCancel)
  cancels?: TossPaymentsCancel[];
  @Type(() => TossPaymentsCard)
  card?: TossPaymentsCard;
  @Type(() => TossPaymentsVirtualAccount)
  virtualAccount?: TossPaymentsVirtualAccount;
  @Type(() => TossPaymentsMobilePhone)
  mobilePhone?: TossPaymentsMobilePhone;
  @Type(() => TossPaymentsGiftCertificate)
  giftCertificate?: TossPaymentsGiftCertificate;
  @Type(() => TossPaymentsTransfer)
  transfer?: TossPaymentsTransfer;
  @Type(() => TossPaymentsFailure)
  failure?: TossPaymentsFailure;
  @Type(() => TossPaymentsCashReceipt)
  cashReceipt?: TossPaymentsCashReceipt;
  @Type(() => TossPaymentsCashReceiptItem)
  cashReceipts?: TossPaymentsCashReceiptItem[];
  @Type(() => TossPaymentsDiscount)
  discount?: TossPaymentsDiscount;
  mid!: string;
}

export class TossPaymentsTransactionWithOrderDto {
  @Type(() => TossPaymentsTransaction)
  transaction!: TossPaymentsTransaction;
  @Type(() => TossPaymentsOrderDto)
  order?: TossPaymentsOrderDto;
}

export class TossPaymentsCheckout {
  url!: string;
}

export class TossPaymentsEasyPay {
  provider!: string;
  amount!: number;
  discountAmount!: number;
}

export class TossPaymentsReceipt {
  url!: string;
}

export class TossPaymentsPaymentResponse {
  version!: string;
  paymentKey!: string;
  type!: 'NORMAL' | 'BILLING' | 'BRANDPAY';
  orderId!: string;
  orderName!: string;
  mId?: string;
  currency!: string;
  method?: string;
  totalAmount!: number;
  balanceAmount!: number;
  status!:
    | 'READY'
    | 'IN_PROGRESS'
    | 'WAITING_FOR_DEPOSIT'
    | 'DONE'
    | 'CANCELED'
    | 'PARTIAL_CANCELED'
    | 'ABORTED'
    | 'EXPIRED';
  requestedAt!: string;
  approvedAt?: string;
  useEscrow!: boolean;
  lastTransactionKey?: string;
  suppliedAmount!: number;
  vat!: number;
  cultureExpense!: boolean;
  taxFreeAmount!: number;
  taxExemptionAmount!: number;
  @Type(() => TossPaymentsCancel)
  cancels?: TossPaymentsCancel[];
  isPartialCancelable!: boolean;
  @Type(() => TossPaymentsCard)
  card?: TossPaymentsCard;
  @Type(() => TossPaymentsVirtualAccount)
  virtualAccount?: TossPaymentsVirtualAccount;
  secret?: string;
  @Type(() => TossPaymentsMobilePhone)
  mobilePhone?: TossPaymentsMobilePhone;
  @Type(() => TossPaymentsGiftCertificate)
  giftCertificate?: TossPaymentsGiftCertificate;
  @Type(() => TossPaymentsTransfer)
  transfer?: TossPaymentsTransfer;
  metadata?: object;
  @Type(() => TossPaymentsReceipt)
  receipt?: TossPaymentsReceipt;
  @Type(() => TossPaymentsCheckout)
  checkout?: TossPaymentsCheckout;
  @Type(() => TossPaymentsEasyPay)
  easyPay?: TossPaymentsEasyPay;
  country!: string;
  @Type(() => TossPaymentsFailure)
  failure?: TossPaymentsFailure;
  @Type(() => TossPaymentsCashReceipt)
  cashReceipt?: TossPaymentsCashReceipt;
  @Type(() => TossPaymentsCashReceiptItem)
  cashReceipts?: TossPaymentsCashReceiptItem[];
  @Type(() => TossPaymentsDiscount)
  discount?: TossPaymentsDiscount;
  mid!: string;
}

export class ListSupportCategoryAdminResponse {
  @Type(() => SupportCategoryAdminApiDto)
  supportCategories!: SupportCategoryAdminApiDto[];
}

export class StoryEpisodeAdminApiDto {
  id!: string;
  title!: string;
  description?: string;
  viewCount!: number;
  status!: StoryEpisodeStatus;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
  @Type(() => Date)
  publishedAt?: Date;
  scheduledPublishDate?: string;
}

export class StoryAdminApiDto {
  id!: string;
  title!: string;
  description!: string;
  coverImageUrl?: string;
  viewCount!: number;
  status!: StoryStatus;
  @Type(() => StoryEpisodeAdminApiDto)
  episodes!: StoryEpisodeAdminApiDto[];
  hashtags!: string[];
  storyCreatorId!: string;
  plotId!: string;
  curationSequence?: number;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
  @Type(() => Date)
  publishedAt?: Date;
  upcomingPublishedDate?: string;
}

export class ListStoryByAdminResponse {
  @Type(() => StoryAdminApiDto)
  stories!: StoryAdminApiDto[];
  nextCursor?: string;
}

export class ListStoryCurationByAdminResponse {
  @Type(() => StoryAdminApiDto)
  stories!: StoryAdminApiDto[];
}

export class ListStaffAdminResponse {
  @Type(() => StaffAdminApiDto)
  members!: StaffAdminApiDto[];
  nextCursor?: number;
}

export class GetSendbirdMigrationCountResponse {
  counts!: object;
}

export class RoomAdminApiDto {
  id!: string;
  @Type(() => UserAdminApiDto)
  user!: UserAdminApiDto;
  @Type(() => PlotApiDto)
  plot!: PlotApiDto;
  @Type(() => LastMessageApiDto)
  lastMessage?: LastMessageApiDto;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class ListRoomAdminResponse {
  @Type(() => RoomAdminApiDto)
  rooms!: RoomAdminApiDto[];
  nextCursor?: number;
}

export class MessageAdminApiDto {
  id!: string;
  roomId!: string;
  @Type(() => MessageApiDtoSender)
  sender!: MessageApiDtoSender;
  @Type(() => MessageApiDtoContentApiDto, {
    discriminator: {
      property: 'type',
      subTypes: [{ value: MessageApiDtoTextApiDto, name: 'TEXT' }],
    },
    keepDiscriminatorProperty: true,
  })
  contents!: MessageApiDtoTextApiDto[];
  @Type(() => MessageVoiceApiDto)
  voice?: MessageVoiceApiDto;
  edited!: boolean;
  candidateId?: string;
  @Type(() => Date)
  messageTime!: Date;
  isIntro!: boolean;
}

export class ListMessageAdminResponse {
  @Type(() => MessageAdminApiDto)
  messages!: MessageAdminApiDto[];
  nextCursor?: string;
}

export class CandidateAdminApiDto {
  id!: string;
  @Type(() => MessageApiDtoTextApiDto)
  contents!: MessageApiDtoTextApiDto[];
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  messageTime!: Date;
  edited!: boolean;
  backgroundImageUrl?: string;
  facialImageUrl?: string;
  @Type(() => MessageVoiceApiDto)
  voice?: MessageVoiceApiDto;
}

export class ListCandidateAdminResponse {
  @Type(() => CandidateAdminApiDto)
  candidates!: CandidateAdminApiDto[];
  nextCursor?: string;
}

export class RoomHistoryApiDto {
  type!: 'USER' | 'BOT' | 'REGEN' | 'EDIT';
  @Type(() => Date)
  time!: Date;
  index!: number;
  content!: string;
}

export class ListRoomHistoryResponse {
  @Type(() => RoomHistoryApiDto)
  histories!: RoomHistoryApiDto[];
}

export class RoomHistorySearchApiDto {
  type!: 'USER' | 'BOT' | 'REGEN' | 'EDIT';
  @Type(() => Date)
  time!: Date;
  roomId!: string;
  content!: string;
  index!: number;
  @Type(() => UserAdminApiDto)
  user?: UserAdminApiDto;
  @Type(() => PlotForCreatorApiDto)
  plot?: PlotForCreatorApiDto;
}

export class RoomSearchByContentResponse {
  @Type(() => RoomHistorySearchApiDto)
  results!: RoomHistorySearchApiDto[];
}

export class RecommendedMessageSearchResponseMessage {
  @Type(() => Date)
  timestamp!: Date;
  userId!: string;
  message!: string;
}

export class RecommendedMessageSearchResponse {
  @Type(() => RecommendedMessageSearchResponseMessage)
  messages!: RecommendedMessageSearchResponseMessage[];
}

export class PagePopupAdminResponse {
  @Type(() => PopupAdminApiDto)
  popups!: PopupAdminApiDto[];
  nextCursor?: number;
}

export class PolicyAdminApiDto {
  id!: string;
  content!: string;
  applyDate!: string;
}

export class ListAdminPolicyResponse {
  @Type(() => PolicyAdminApiDto)
  policies!: PolicyAdminApiDto[];
}

export class ListPlotAdminResponse {
  @Type(() => PlotForCreatorAdminApiDto)
  plots!: PlotForCreatorAdminApiDto[];
  nextCursor?: string;
}

export class PlotLifecycleApiDto {
  plotId!: string;
  stage!: PlotLifecycleStage;
  rank?: PlotLifecycleRank;
  targetGender?: Gender;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  stageUpdatedAt!: Date;
}

export class UncheckedPlotCountResponse {
  count!: number;
}

export class PagePlotSearchAdminResponse {
  @Type(() => PlotApiDto)
  plots!: PlotApiDto[];
  nextCursor?: string;
}

export class GetPlotCountByKeywordAdminResponse {
  count!: number;
}

export class PlotMonitoringCountByAdminAndActionResponseItem {
  adminEmail!: string;
  stage!: 'PROFILE_IMAGE' | 'PROMPT';
  action!: PlotStatus;
  count!: number;
}

export class PlotMonitoringCountByAdminAndActionResponse {
  @Type(() => PlotMonitoringCountByAdminAndActionResponseItem)
  items!: PlotMonitoringCountByAdminAndActionResponseItem[];
}

export class PlotDiscoveryAdminApiDto {
  plotId!: string;
  name!: string;
  interactionCountWithRegen!: number;
  shortDescription!: string;
  greeting?: string;
  @Type(() => PlotIntroApiDto)
  intros!: PlotIntroApiDto[];
  hashtags!: string[];
  pool!:
    | 'HIGH_PERSONALIZED'
    | 'MEDIUM_PERSONALIZED'
    | 'HIGH_RANDOM'
    | 'MEDIUM_RANDOM'
    | 'MINIMUM_RANDOM'
    | 'UNQUALIFIED_RANDOM';
}

export class ListPlotDiscoveryAdminResponse {
  @Type(() => PlotDiscoveryAdminApiDto)
  plots!: PlotDiscoveryAdminApiDto[];
}

export class OrderBy {
  property!:
    | 'CREATED_AT'
    | 'UPDATED_AT'
    | 'INTERACTION_COUNT'
    | 'INTERACTED_USER_COUNT'
    | 'AVERAGE_PLAY_TIME_MINUTES'
    | 'PLAY_USER_COUNT';
  direction!: 'ASC' | 'DESC';
}

export class PlotAdvancedSearchOption {
  plotId?: string;
  name?: string;
  creatorId?: string;
  descriptionContains?: string;
  country?: string;
  interactionCountMoreThan?: number;
  interactionUserMoreThan?: number;
  status?: PlotStatus[];
  hashtag?: string;
  @Type(() => Date)
  createdAtStartedAt?: Date;
  @Type(() => Date)
  createdAtEndedAt?: Date;
  @Type(() => Date)
  updatedAtStartedAt?: Date;
  @Type(() => Date)
  updatedAtEndedAt?: Date;
  isSnapshot?: boolean;
  isPrivate?: boolean;
  @Type(() => OrderBy)
  orderBy?: OrderBy;
  averagePlayTimeMinutesMoreThan?: number;
  playUserCountMoreThan?: number;
  hasVoice?: boolean;
  hasMultiTurnIntros?: boolean;
}

export class PlotWithStatAdminApiDto {
  @Type(() => PlotForCreatorAdminApiDto)
  plot!: PlotForCreatorAdminApiDto;
  averagePlayTimeMinutes?: number;
  playUserCount?: number;
}

export class PagePlotAdvancedSearchAdminResponse {
  @Type(() => PlotWithStatAdminApiDto)
  plots!: PlotWithStatAdminApiDto[];
  nextCursor?: string;
}

export class PlotStatApiDto {
  plotId!: string;
  averagePlayTimeMinutes!: number;
  playUserCount!: number;
  showUserCount!: number;
  averagePlayTimeMinutesMale!: number;
  playUserCountMale!: number;
  showUserCountMale!: number;
  averagePlayTimeMinutesFemale!: number;
  playUserCountFemale!: number;
  showUserCountFemale!: number;
  @Type(() => Date)
  updatedAt!: Date;
}

export class ListHighQualityPlotStatResponse {
  @Type(() => PlotStatApiDto)
  plotStats!: PlotStatApiDto[];
}

export class PlotReportAdminApiDto {
  id!: number;
  plotId!: string;
  userId!: string;
  type!: ReportType;
  reason?: string;
  status!: ReportStatus;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListPlotReportAdminResponse {
  @Type(() => PlotReportAdminApiDto)
  reports!: PlotReportAdminApiDto[];
  nextCursor?: number;
}

export class GroupedPlotReportAdminApiDto {
  plotId!: string;
  reportUserCount!: number;
  reportCount!: number;
  @Type(() => Date)
  lastCreatedAt!: Date;
}

export class ListGroupedPlotReportAdminResponse {
  @Type(() => GroupedPlotReportAdminApiDto)
  reports!: GroupedPlotReportAdminApiDto[];
  nextCursor?: number;
}

export class ListPlotPoolAdminResponse {
  @Type(() => PlotPoolAdminApiDto)
  plotPools!: PlotPoolAdminApiDto[];
}

export class ListPlotPoolRelationAdminResponse {
  @Type(() => PlotPoolRelationAdminApiDto)
  plotPoolRelations!: PlotPoolRelationAdminApiDto[];
}

export class ListPlotLifecyclePoolAdminResponse {
  @Type(() => PlotLifecyclePoolAdminApiDto)
  plotLifecyclePools!: PlotLifecyclePoolAdminApiDto[];
}

export class ListPlotLifecyclePoolRelationResponse {
  @Type(() => PlotLifecyclePoolRelationAdminApiDto)
  plotLifecyclePoolRelations!: PlotLifecyclePoolRelationAdminApiDto[];
}

export class ListPlotLifecyclePoolCandidateAdminResponse {
  candidatePlotIds!: string[];
}

export class PlotImageScanInfoAdminApiDto {
  plotId!: string;
  characterId!: string;
  url!: string;
  style!: PlotImageStyle;
  gender!: PlotImageGender;
  sexual!: PlotImageSexual;
}

export class ListPlotImageScanInfoAdminResponse {
  @Type(() => PlotImageScanInfoAdminApiDto)
  plotImageScanInfos!: PlotImageScanInfoAdminApiDto[];
}

export class UncheckedPlotImageCountAdminResponse {
  count!: number;
}

export class PlotImageMonitoringHistoryAdminApiDto {
  id!: string;
  plotId!: string;
  adminId!: string;
  action!: PlotImageMonitoringAction;
  imageUrl!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListPlotImageMonitoringHistoryAdminResponse {
  @Type(() => PlotImageMonitoringHistoryAdminApiDto)
  histories!: PlotImageMonitoringHistoryAdminApiDto[];
}

export class PlotImageMonitoringCountByAdminAndActionAdminResponseItem {
  adminEmail!: string;
  action!: PlotImageMonitoringAction;
  count!: number;
}

export class PlotImageMonitoringCountByAdminAndActionAdminResponse {
  @Type(() => PlotImageMonitoringCountByAdminAndActionAdminResponseItem)
  items!: PlotImageMonitoringCountByAdminAndActionAdminResponseItem[];
}

export class OpenStorePurchasePhaseAdminApiDto {
  id!: string;
  userId!: string;
  productId!: string;
  status!: OpenStorePurchasePhaseAdminApiDtoStatus;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class ListOpenStorePurchasePhaseAdminResponse {
  @Type(() => OpenStorePurchasePhaseAdminApiDto)
  phases!: OpenStorePurchasePhaseAdminApiDto[];
}

export class PlayStoreTokenResponse {
  token!: string;
}

export class PlayStoreProductPurchase {
  kind!: string;
  purchaseTimeMillis!: number;
  purchaseState!: 'PURCHASED' | 'CANCELED' | 'PENDING';
  consumptionState!: 'YET_CONSUMED' | 'CONSUMED';
  developerPayload!: string;
  orderId?: string;
  purchaseType?: 'TEST' | 'PROMOTION' | 'REWARD';
  acknowledgementState!: 'UNACKNOWLEDGED' | 'ACKNOWLEDGED';
  quantity?: number;
  obfuscatedExternalAccountId?: string;
  obfuscatedExternalProfileId?: string;
  regionCode!: string;
}

export class JWSTransactionDecodedPayload {
  rawType?: string;
  rawInAppOwnershipType?: string;
  rawRevocationReason?: number;
  rawOfferType?: number;
  rawEnvironment?: string;
  rawTransactionReason?: string;
  rawOfferDiscountType?: string;
  unknownFields?: object;
  originalTransactionId?: string;
  transactionId?: string;
  webOrderLineItemId?: string;
  bundleId?: string;
  productId?: string;
  subscriptionGroupIdentifier?: string;
  purchaseDate?: number;
  originalPurchaseDate?: number;
  expiresDate?: number;
  quantity?: number;
  type?:
    | 'Auto-Renewable Subscription'
    | 'Non-Consumable'
    | 'Consumable'
    | 'Non-Renewing Subscription';
  appAccountToken?: string;
  inAppOwnershipType?: 'FAMILY_SHARED' | 'PURCHASED';
  signedDate?: number;
  revocationReason?: '1' | '0';
  revocationDate?: number;
  isUpgraded?: boolean;
  offerType?: '1' | '2' | '3';
  offerIdentifier?: string;
  environment?: 'Sandbox' | 'Production' | 'Xcode' | 'LocalTesting';
  storefront?: string;
  storefrontId?: string;
  transactionReason?: 'PURCHASE' | 'RENEWAL';
  price?: number;
  currency?: string;
  offerDiscountType?: 'FREE_TRIAL' | 'PAY_AS_YOU_GO' | 'PAY_UP_FRONT';
}

export class ListMinimumAppVersionResponse {
  @Type(() => MinimumAppVersionApiDto)
  minimumAppVersions!: MinimumAppVersionApiDto[];
}

export class MemoryAdminApiDto {
  id!: string;
  userId!: string;
  plotId!: string;
  roomId!: string;
  content!: string;
  startTurnCount!: number;
  endTurnCount!: number;
  isActive!: boolean;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListMemoryAdminResponse {
  @Type(() => MemoryAdminApiDto)
  memories!: MemoryAdminApiDto[];
}

export class ListMaintenanceResponse {
  @Type(() => MaintenanceApiDto)
  maintenances!: MaintenanceApiDto[];
}

export class LayoutApiDto {
  id!: string;
  name!: string;
  @Type(() => LayoutApiDtoFilter)
  filters!: LayoutApiDtoFilter[];
  priority!: number;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class ListLayoutResponse {
  @Type(() => LayoutApiDto)
  layouts!: LayoutApiDto[];
}

export class ListLayoutSectionResponse {
  @Type(() => LayoutSectionApiDto)
  layoutSections!: LayoutSectionApiDto[];
}

export class Mapping {
  display!: string;
  content!: string;
}

export class LayoutSessionMappingApiDto {
  @Type(() => Mapping)
  mappings!: Mapping[];
}

export class LayoutNominatorNotificationAdminApiDto {
  id!: number;
  layoutId!: string;
  layoutSectionId!: string;
  plotId!: string;
  @Type(() => Date)
  createdAt!: Date;
}

export class ListLayoutNominatorNotificationResponse {
  @Type(() => LayoutNominatorNotificationAdminApiDto)
  notifications!: LayoutNominatorNotificationAdminApiDto[];
  nextCursor?: number;
}

export class LayoutNominatorNotificationTargetApiDto {
  creatorId!: string;
  plotId!: string;
  layoutSectionId!: string;
}

export class ListLayoutNominatorNotificationTargetResponse {
  @Type(() => LayoutNominatorNotificationTargetApiDto)
  targets!: LayoutNominatorNotificationTargetApiDto[];
}

export class KeywordAdminApiDto {
  id!: number;
  keywordType!: KeywordType;
  matchType!:
    | 'WHITE_SPACE_SEPERATED'
    | 'CONTAINS'
    | 'EXACT'
    | 'REMOVE_WHITE_SPACE';
  keyword!: string;
}

export class PageKeywordAdminApiDtoLong {
  @Type(() => KeywordAdminApiDto)
  items!: KeywordAdminApiDto[];
  nextCursor?: number;
  pageIndex?: number;
}

export class PageIpBanResponse {
  ips!: string[];
  nextCursor?: string;
}

export class ListFeatureFlagForAdminResponse {
  @Type(() => FeatureFlagForAdminApiDto)
  featureFlags!: FeatureFlagForAdminApiDto[];
  nextCursor?: number;
}

export class ListFaqAdminResponse {
  @Type(() => FaqAdminApiDto)
  faqs!: FaqAdminApiDto[];
}

export class ListFaqFavoriteAdminResponse {
  @Type(() => FaqFavoriteAdminApiDto)
  faqFavorites!: FaqFavoriteAdminApiDto[];
}

export class ListContactReplyAdminResponse {
  @Type(() => ContactReplyAdminApiDto)
  contactReplies!: ContactReplyAdminApiDto[];
}

export class ContactSearchOption {
  mainCategoryId?: string;
  subCategoryId?: string;
  userId?: string;
  tag?: string;
  statuses?: ContactStatus[];
  query?: string;
  @Type(() => Date)
  startAt?: Date;
  @Type(() => Date)
  endAt?: Date;
}

export class ContactSummaryAdminApiDto {
  id!: string;
  mainCategoryId!: string;
  subCategoryId!: string;
  userId!: string;
  adminId?: string;
  title!: string;
  status!: ContactStatus;
  @Type(() => Date)
  createdAt!: Date;
  @Type(() => Date)
  updatedAt!: Date;
}

export class ListContactAdminResponse {
  @Type(() => ContactSummaryAdminApiDto)
  contacts!: ContactSummaryAdminApiDto[];
  nextPage?: number;
}

export class CountContactAdminResponse {
  count!: number;
}

export class ListContactTemplateAdminResponse {
  @Type(() => ContactTemplateAdminApiDto)
  contactTemplates!: ContactTemplateAdminApiDto[];
}

export class ContactStaticsAdminApiDto {
  totalContactCount!: number;
  pendingContactCount!: number;
  pendingChildContactCount!: number;
  inProgressContactCount!: number;
  completedContactCount!: number;
  closedContactCount!: number;
  userReplyCount!: number;
  adminReplyCount!: number;
  userRepliedRate!: number;
  avgFirstReplyTime!: number;
}

export class UnitPriceAndAmount {
  unitPrice!: number;
  amount!: number;
}

export class CoinTransactionDailyReportApiDto {
  id!: number;
  date!: string;
  country!: Country;
  @Type(() => UnitPriceAndAmount)
  deposits!: UnitPriceAndAmount[];
  @Type(() => UnitPriceAndAmount)
  withdrawals!: UnitPriceAndAmount[];
  @Type(() => UnitPriceAndAmount)
  balances!: UnitPriceAndAmount[];
}

export class CoinProductAdminApiDto {
  id!: string;
  name!: string;
  price!: number;
  discountedPrice!: number;
  type!: CoinProductType;
  durationDays?: number;
  status!: ProductStatus;
}

export class ListCoinProductsAdminResponse {
  @Type(() => CoinProductAdminApiDto)
  products!: CoinProductAdminApiDto[];
}

export class PageChatMABExperimentResponse {
  @Type(() => ChatMABExperimentAdminApiDto)
  chatMABExperiments!: ChatMABExperimentAdminApiDto[];
  nextCursor?: number;
}

export class ListCharacterSkinAdminResponse {
  @Type(() => CharacterSkinAdminApiDto)
  skins!: CharacterSkinAdminApiDto[];
}

export class BannerAdminApiDto {
  id!: number;
  country!: string;
  clientType!: 'APP' | 'WEB';
  titlePrimary!: string;
  titleSecondary!: string;
  imageUrl?: string;
  priority!: number;
  @Type(() => ClickAction, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: ProPurchaseModal, name: 'proPurchaseModal' },
        { value: ExternalLink, name: 'externalLink' },
        { value: Navigate, name: 'navigate' },
        { value: EventModal, name: 'eventModal' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  clickAction!: EventModal | ExternalLink | Navigate | ProPurchaseModal;
  isActive!: boolean;
  minimumAppVersion?: string;
  @Type(() => TargetABExperimentApiDto)
  targetABExperiment?: TargetABExperimentApiDto;
}

export class ListAdminBannerResponse {
  @Type(() => BannerAdminApiDto)
  banners!: BannerAdminApiDto[];
  nextCursor?: number;
}

export class ListAnnouncementAdminResponse {
  @Type(() => AnnouncementAdminApiDto)
  announcements!: AnnouncementAdminApiDto[];
  nextCursor?: string;
}

export class AdminApiDto {
  id!: string;
  email!: string;
  name!: string;
  profileImageUrl?: string;
  role!: 'ALL' | 'MONITORING';
}

export class ListAdminResponse {
  @Type(() => AdminApiDto)
  admins!: AdminApiDto[];
}

export class ListABUserApiDto {
  @Type(() => ABUserAdminApiDto)
  abUsers!: ABUserAdminApiDto[];
}

export class ListABExperimentAdminResponse {
  @Type(() => ABExperimentAdminApiDto)
  experiments!: ABExperimentAdminApiDto[];
  nextCursor?: number;
}

export class UnblockUserRequest {
  userId!: string;
}

export class MessagePointer {
  roomId!: string;
  messageId!: string;
  lastTurnCount?: number;
}

export class DeleteMessageRequest {
  @Type(() => MessagePointer)
  messagePointer!: MessagePointer;
}

export class DeleteMessageResponse {
  @Type(() => RoomApiDto)
  room!: RoomApiDto;
}

export class UnblockHashtagRequest {
  hashtag!: string;
}

export class UnblockPlotRequest {
  plotId!: string;
}

export class DeleteStoryCurationByAdminRequest {
  storyId!: string;
}

export class DeletePlotLifecyclePoolCandidateAdminRequest {
  plotIds!: string[];
}
